export default {
  translation: {
    commonUsedWords: {
      login: 'Accedi',
      email: 'Indirizzo email',
      password: 'Password',
      emailIsRequired: "È richiesta l'email",
      mustBeAValidEmail: "Deve essere un'email valida",
      deviceSerialNumber: 'Numero di serie del dispositivo',
      next: 'Avanti',
      back: 'Indietro',
      success: 'Successo',
      submit: 'Invia',
      firstName: 'Nome',
      firstNameIsRequired: 'Il nome è richiesto',
      lastName: 'Cognome',
      lastNameIsRequired: 'Il cognome è richiesto',
      save: 'Salva',
      delete: 'Elimina',
      undoChanges: 'Annulla modifiche',
      cancel: 'Annulla',
      loading: 'Caricamento...',
      yes: 'Sì',
      no: 'No',
      clear: 'Cancella',
      confirm: 'Confermare',
      noOption: 'Nessuna opzione',
      noCompressorTemplatesFound: 'Nessun modello di compressore trovato',
      openText: 'Apri',
      edit: 'Modifica',
      logout: 'Esci',
      locked: 'Bloccato',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      ok: 'Ok',
      okay: 'Va bene',
      done: 'Fatto',
      comingSoon: 'Prossimamente...',
      reset: 'Reimposta',
      attention: 'Attenzione',
      note: 'Nota',
      continue: 'Continua',
      finish: 'Termina',
      required: 'Questo campo è obbligatorio',
      close: 'Chiudi',
      copiedToClipboard: 'Copiato negli appunti',
      apply: 'Applica',
    },
    api: {
      auth: {
        fieldsAreMissing: 'Mancano campi obbligatori',
        userNotFound: 'Utente non trovato',
        missingRefreshToken: 'Manca il token di aggiornamento',
        cannotRefreshToken: 'Impossibile aggiornare il token',
      },
      helpers: {
        error: 'Errore',
        invalidHTTPMethod: 'Metodo HTTP non valido',
      },
    },
    components: {
      autocompleteField: {
        presets: 'Predefiniti',
        results: 'Risultati',
      },
      dateRangePicker: {
        changeDates: 'Cambia date',
        selectDateRange: 'Seleziona un intervallo di date',
        startDate: 'Data di inizio',
        endDate: 'Data di fine',
        datePresets: {
          label: 'Preimpostazioni data',
          today: 'Oggi',
          yesterday: 'Ieri',
          last7Days: 'Ultimi 7 giorni',
          last30Days: 'Ultimi 30 giorni',
          thisWeek: 'Questa settimana',
          lastWeek: 'Settimana scorsa',
          thisMonth: 'Questo mese',
          lastMonth: 'Mese scorso',
          thisYear: "Quest'anno",
          lastYear: 'Anno scorso',
          allTime: 'Tutto il tempo',
        },
        calendar: {
          weekDays: {
            mon: 'Lu',
            tue: 'Ma',
            wed: 'Me',
            thu: 'Gi',
            fri: 'Ve',
            sat: 'Sa',
            sun: 'Do',
          },
          months: {
            january: 'Gennaio',
            february: 'Febbraio',
            march: 'Marzo',
            april: 'Aprile',
            may: 'Maggio',
            june: 'Giugno',
            july: 'Luglio',
            august: 'Agosto',
            september: 'Settembre',
            october: 'Ottobre',
            november: 'Novembre',
            december: 'Dicembre',
          },
        },
      },
      confirmEmail: {
        confirmEmail: 'Conferma indirizzo email',
        confirmEmailIsRequired: "È richiesta la conferma dell'email",
        emailNotMatched: 'Le voci di posta elettronica non corrispondono',
      },
      confirmPassword: {
        confirmPassword: 'Conferma password',
        confirmPasswordIsRequired: 'È richiesta la conferma della password',
        newPasswordIsRequired: 'È richiesta una nuova password',
        showPassword: 'Mostra password',
        passwordLength: 'Le password devono contenere almeno 6 caratteri',
        passwordContainSpaces: 'La password non deve contenere spazi',
        passwordNotMatch: 'Le voci della password non corrispondono',
        newPassword: 'Nuova password',
      },
      confirmModal: {
        areYouSure: 'Sei sicuro?',
      },
      appliedFilters: {
        between: 'Tra {{firstValue}} e {{secondValue}}',
        bottom: 'Fondo {{primaryValue}}%',
        top: 'Cima {{primaryValue}}%',
        activeFilters: 'Filtri attivi',
        active: 'attivo',
        closed: 'chiuso',
      },
      editTable: {
        editTable: 'Modifica tabella',
        selectDeselect: 'Seleziona/Deseleziona valori della tabella',
        resetToDefault: 'Ripristina le impostazioni predefinite',
      },
      errorBoundary: {
        oops: 'Ops! È successo qualcosa di inaspettato.',
        tryAgain: 'Per favore riprova! Se il problema persiste, contatta il tuo amministratore.',
        refresh: 'Aggiorna',
      },
      noResultFound: {
        noResultFoundTryAgain: 'Spiacenti, nessun risultato trovato. Per favore riprova.',
      },
      permissionGuard: {
        invalidPermission: "Struttura di autorizzazione non valida, previsti 3 elementi nell'array",
      },
      preview: {
        findInView: 'Trova nella vista',
        showDetails: 'Mostra dettagli',
        closeEsc: 'Chiudi (Esc)',
        prevLeftArrow: 'Precedente (Freccia sinistra)',
        nextRightArrow: 'Successivo (Freccia destra)',
        proceedWithoutSaving: 'Naviga senza salvare',
        continueEditing: 'Continua a modificare',
        unsavedChanges: {
          partTwo: 'Hai ',
          partThree: 'MODIFICHE NON SALVATE',
          partFour: '. Navigare senza salvare scarterà tutte le modifiche. Sei sicuro?',
        },
      },
      printRecord: {
        title: 'Registro',
        date: 'Data:',
        location: 'Posizione',
        leakDetails: 'Dettagli',
        leakParameters: 'Parametri',
        energyLoss: 'Perdita energetica',
        leakSourceEquipment: 'Equipaggiamento sorgente',
        notes: 'Note',
        leakEventStatus: 'Stato',
        requiredAction: 'Azione richiesta',
        leakSourceImage: 'Immagine sorgente',
        sourceImages: 'Immagini sorgente',
        additionalImages: 'Immagini aggiuntive',
        additionalImage: 'Immagine aggiuntiva',
        smartLeakTag: 'Etichetta intelligente',
        workRef: 'Riferimento di lavoro',
        lossPerYear: 'Perdita ({{currency}}/anno)',
        costOfEnergy: "Costo dell'energia ({{currency}}/kWh)",
        eventRecordTitle: 'Registro eventi',
        recordedOn: 'Registrato il {{date}}',
        eventParameters: "Parametri dell'evento",
        eventMetrics: "Metriche dell'evento",
        sourceEquipment: 'Apparecchiatura di origine',
        eventStatus: "Stato dell'evento",
        sourceImageCaptures: 'Acquisizioni immagini di origine',
        fftNotAvailable: 'Dati FFT non disponibili per questo registro',
        imageNotAvailable: 'Immagine non disponibile',
        generatedOn: 'Generato il {{date}}',
        pageOfTotal: 'Pagina {{page}} / {{total}}',
        energyPerYear: 'Energia (kWh/anno)',
      },
      exportSectionsDialog: {
        title: 'Scegli le sezioni da esportare',
        exportingSingular: 'Esportazione di 1 registro.',
        exportingPlural: 'Esportazione di {{count}} registri.',
        selectSectionsHint: 'Seleziona le sezioni da includere nel PDF.',
        visualizationsHint:
          'Le visualizzazioni richiedono un rendering aggiuntivo e potrebbero richiedere alcuni secondi in più per esportazioni grandi.',
        default: 'Predefinito',
        selectAll: 'Seleziona tutto',
        groups: {
          summary: 'Riepilogo',
          clientLocation: 'Cliente e posizione',
          recordDetails: 'Dettagli del registro',
          source: 'Origine',
          status: 'Stato',
          visualizations: 'Visualizzazioni',
        },
        sections: {
          summary: 'Pagina di riepilogo',
          clientInfo: 'Informazioni cliente',
          leakParameters: "Parametri dell'evento",
          energyLoss: 'Perdita di energia / Parametri elettrici',
          leakMetrics: "Metriche dell'evento",
          sourceEquipment: 'Apparecchiatura di origine + immagini',
          leakStatus: "Stato dell'evento",
          fft: 'Spettro di frequenza FFT',
        },
      },
      assignedAction: {
        actionHeader: {
          deleteAssignmentSuccess: "L'assegnazione è stata eliminata",
          deleteAssignmentError: "Impossibile eliminare l'assegnazione. Per favore riprova più tardi",
          currentlyAssigned: 'Azione attualmente assegnata',
          repairedBy: 'Riparato da',
          text: 'Stai per eliminare questa assegnazione. Questa azione non può essere annullata',
        },
        actionSaveDate: 'Ultimo salvataggio',
      },
      visibleColumnsPopper: {
        tableValues: 'Seleziona / Deseleziona valori della tabella',
      },
      tableHead: {
        deselectCurrentPage: 'Deseleziona pagina corrente',
        selectCurrentPage: 'Seleziona pagina corrente',
      },
      coverPage: {
        costDisclaimer:
          'Nota: Le perdite finanziarie e i risparmi sui costi si riferiscono solo alle registrazioni di perdite di aria compressa.',
        title: 'Rapporto dei Registri',
        reportDate: 'Data del rapporto: {{date}}',
        poweredBy: 'Offerto da {{companyName}}<reg>®</reg>',
        date: 'Intervallo di date: {{from}} - {{to}}',
        includedRecords: 'Registrazioni incluse: {{count}}',
        totalLoss: 'Perdita totale',
        lossByCurrency: '{{currency}}: {{loss}}',
        totalKwhLoss: 'Perdita totale di kWh: {{kwh}} kWh/anno',
      },
      tagsCoverPage: {
        title: 'Rapporto Smart Tags',
        reportDate: 'Data del rapporto: {{date}}',
        poweredBy: 'Offerto da {{companyName}}<reg>®</reg>',
        date: 'Intervallo di date: {{from}} - {{to}}',
        includedTags: 'Smart Tags inclusi: {{count}}',
        includedRecords: 'Registrazioni incluse: {{count}}',
        totalKwhLoss: 'Perdita totale di kWh: {{kwh}} kWh/anno',
      },
      EnergyEfficiencyGauge: {
        title: 'Valutazione dell’efficienza energetica',
        recommendedRange: 'Intervallo di efficienza consigliato',
        levels: {
          good: {
            label: 'Buono',
            description:
              'Il sistema funziona vicino al suo potenziale ideale e più efficiente. Compressore moderno ad alta efficienza (es. azionamento a velocità variabile o compressore a vite rotativo completamente carico al punto di progetto)',
          },
          average: {
            label: 'Medio',
            description:
              'Il sistema presenta inefficienze tipiche; c’è margine di miglioramento. Sistema industriale tipico, forse con apparecchiature più datate o funzionante principalmente a carico parziale con controlli meno efficienti (es. carico/scarico)',
          },
          poor: {
            label: 'Scarso',
            description:
              'Il sistema è altamente inefficiente (probabilmente a causa di perdite, attrezzatura vecchia o costi elevati dell’energia) e necessita di intervento immediato. Sistema datato e poco mantenuto, oppure che opera con estrema inefficienza a carico parziale (es. più compressori fatti funzionare in modo non ottimizzato)',
          },
        },
      },
    },
    constants: {
      qualifiers: {
        EQUAL_TO: 'Uguale a',
        LESS_THAN: 'Minore di',
        GREATER_THAN: 'Maggiore di',
        LESS_THAN_OR_EQUAL_TO: 'Minore o uguale a',
        GREATER_THAN_OR_EQUAL_TO: 'Maggiore o uguale a',
        BETWEEN_A_AND_Y: 'Tra',
        TOP_PERCENT: 'Cima "x"%',
        BOTTOM_PERCENT: 'Fondo "x"%',
      },
      recordFields: {
        CREATED_AT: 'Data di creazione',
        RECORD_ID: 'Numero di registrazione',
        DOCUMENT_ID: 'Numero di registrazione',
        DOLLARS_PER_YEAR: 'Perdita',
        GAS_COMPONENT: 'Gas/Componente',
        LEAK_TYPE: 'Profilo di fuga',
        DATE_TIME: 'Data/Orario di creazione',
        DB_PEAK: 'Punta dB',
        COMPANY: 'Azienda',
        NOTES: 'Note',
        USER: 'Utente',
        EQUIPMENT_TAG: 'Etichetta di apparecchiatura/Componente',
        FLOW: 'Flusso (m³/h)',
        EQUIPMENT: 'Unità/Edificio/Macchina',
        ROUTE: 'Percorso',
        ROUTE_LOCATION: 'Posizione del percorso',
        ROUTE_EQUIPMENT_NAME: 'Attrezzatura di Percorso',
        PROJECT_SURVEY: 'Riferimento a audit/indagine',
        OUTAGE_STATUS: 'Richiesto spegnimento/fermo?',
        FACILITY: 'Impianto/Sito',
        ACTION_STATUS: "Stato dell'azione",
        SERVICE_TYPE: 'Servizio/Tipo',
        DB_ACTIVE: 'dB Attivo',
        REFERENCE_ID: 'Riferimento al progetto/ID di indagine',
        AMBIENT_TEMPERATURE: 'Temperatura ambiente (°C)',
        LEAK_PRESSURE: 'Pressione (kPag)',
        LEAK_TEMPERATURE: 'Temperatura del gas (°C)',
        LEAK_CATEGORY: 'Categoria',
        DISTANCE: 'Distanza (m)',
        GAS_COST: 'Costo del gas ($/m³)',
        COMPRESSOR_FLOW: 'm³/h per BHP',
        DEVICE_ID: 'ID dispositivo',
        COMPRESSOR_BHP: 'BHP del compressore',
        COMPRESSOR_TYPE: 'Tipo di compressore',
        MOTOR_EFFICIENCY: 'Efficienza del motore (%)',
        ENERGY_COST: "Costo dell'energia ($/kWh)",
        HOURS: 'Ore di funzionamento/anno',
        LOCATION: 'Posizione',
        LAST_MODIFIED: 'Data/Ora ultimo salvataggio',
        POWER_LOAD: '% Potenza carica piena',
        CLIENT: 'Cliente',
        SERVICE: 'Servizio',
        CAPACITY: '% Capacità',
        EQUIPMENT_TYPE: 'Tipo di apparecchiatura/Componente',
        SMART_TAG: 'Etichetta intelligente n.',
        WORK_REF: 'Rif. lavoro n.',
        REPAIRED_BY: 'Riparato da',
        ALTITUDE: 'Altitudine (m)',
        REQUIRED_ACTION: 'Azioni richieste',
        FREQUENCY_LOW_BOUND: 'Frequenza (bassa)',
        FREQUENCY_HIGH_BOUND: 'Frequenza (alta)',
        SENSITIVITY: 'Sensibilità',
        KWH_PER_YEAR: 'kWh/anno',
        ASSIGNED_BY: 'Assegnato da',
        ASSIGNED_TO: 'Assegnato a',
        ASSIGNED_DATE: 'Data di assegnazione',
        LOSS_PER_YEAR: 'Perdita (per anno)',
        ASSIGNED: 'Assegnato',
        CREATOR_USER_ID: 'ID utente',
        CURRENCY: 'Valuta',
        COMPLETED_ON: 'Completato il',
        IMAGES: 'Immagini sorgenti',
        ACTION_STATUS_MODIFIED: "Stato dell'azione modificato",
        TYPE: 'Tipo',
      },
      electricalRecordFields: {
        REGION: 'Regione',
        LOCATION_TYPE: 'Tipo di Località',
        VOLTAGE: 'Tensione',
        PHASE: 'Fase',
        FREQUENCY: 'Frequenza',
        ELECTRICAL_EQUIPMENT_TAG: 'Apparecchiatura/Componente',
        ELECTRICAL_EQUIPMENT_TYPE: 'Tipo di Apparecchiatura/Componente',
        FAULT_TYPE: 'Tipo di Guasto',
        ELECTRICAL_NOTES: 'Note',
      },
      IMPERIAL_LABELS: {
        FLOW: 'Flusso (cfm)',
        AMBIENT_TEMPERATURE: 'Temperatura ambiente (°F)',
        LEAK_PRESSURE: 'Pressione (psi)',
        LEAK_TEMPERATURE: 'Temperatura del gas (°F)',
        DISTANCE: 'Distanza (ft)',
        GAS_COST: 'Costo del gas ($/ft³)',
        COMPRESSOR_FLOW: 'cfm per BHP',
        ALTITUDE: 'Altitudine (ft)',
      },
      METRIC_EU_LABELS: {
        FLOW: 'Flusso (m³/min)',
        LEAK_PRESSURE: 'Pressione (bar)',
        COMPRESSOR_FLOW: 'm³/min per BHP',
      },
      userFields: {
        EMAIL: 'Email',
        ROLE: 'Ruolo',
        DEVICE_ID: 'ID del dispositivo',
        SUBSCRIPTION_RENEWAL_DATE: "Data di rinnovo dell'abbonamento",
        DATE_TIME: 'Creato',
        ACTIVE: 'Stato',
        SOFTWARE_VERSION: 'Versione software',
        FIRMWARE_VERSION: 'Versione firmware',
        FIRST_NAME: 'Nome',
        LAST_NAME: 'Cognome',
        COMPANY_SLUG: 'Azienda',
        COMPANY_NAME: 'Azienda',
      },
      auditFields: {
        documentId: 'Numero ID record',
        companyName: "Nome dell'azienda",
        auditorName: 'Nome del revisore',
        auditorEmail: 'Email del revisore',
        createdAt: 'Creato il',
        updatedAt: 'Aggiornato il',
        comment: 'Commenti',
        isLocked: 'Blocco di audit',
      },
      deviceFields: {
        DEVICE_ID: 'ID del dispositivo',
        ACTIVE: 'Stato',
        REGISTERED_ON: 'Attivato il',
        EVENT_COUNT: 'Record',
        UNIQUE_COMPANIES: 'Aziende',
        LAST_USED_AT: 'Ultimo utilizzo il',
        LAST_USED_BY_NAME: 'Ultimo nome utilizzato',
        LAST_USED_BY_EMAIL: 'Ultima email utilizzata',
        LOCATION: 'Ultima posizione utilizzata',
        FIRMWARE_VERSION: 'Versione firmware',
      },
      enpisFields: {
        labels: {
          NO_OF_LEAKS_FOUND: '# Perdite trovate',
          NO_OF_LEAKS_REPAIRED: '# Perdite riparate',
          PERCENT_LEAKS_REPAIRED: '% Perdite riparate',
          VOL_FLOW_FOUND: 'Flusso volumetrico trovato (m³/h)',
          VOL_FLOW_REPAIRED: 'Flusso volumetrico riparato (m³/h)',
          PERCENT_VOL_FLOW_REPAIRED: '% Flusso riparato',
          VALUE_FOUND: 'Valore trovato',
          VALUE_REPAIRED: 'Valore riparato',
          ENERGY_SAVING_OPPORTUNITY_FOUND: 'Opportunità di risparmio energetico (trovata) (kWh)',
          ENERGY_SAVING_OPPORTUNITY_PERCENT: 'Opportunità di risparmio energetico % (trovato vs calcolato o misurato)',
          ENERGY_SAVING_REALIZED_FIXED: 'Risparmio energetico realizzato (riparato) (kWh)',
          ENERGY_SAVING_REALIZED_PERCENT: '% Risparmio energetico realizzato (riparato vs calcolato o misurato)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Pressione di controllo del sistema ridotta (kPag)',
        },
        labelsImperial: {
          VOL_FLOW_FOUND: 'Flusso volumetrico trovato (cfm)',
          VOL_FLOW_REPAIRED: 'Flusso volumetrico riparato (cfm)',
          ENERGY_SAVING_OPPORTUNITY_FOUND: 'Opportunità di risparmio energetico (trovata) (BTU)',
          ENERGY_SAVING_REALIZED_FIXED: 'Risparmio energetico realizzato (riparato) (BTU)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Pressione di controllo del sistema ridotta (psi)',
        },
        labelsMetricEu: {
          VOL_FLOW_FOUND: 'Flusso volumetrico trovato (m³/min)',
          VOL_FLOW_REPAIRED: 'Flusso volumetrico riparato (m³/min)',
          SYSTEM_CONTROL_PRESSURE_REDUCED: 'Pressione di controllo del sistema ridotta (bar)',
        },
        columns: {
          PERFORMANCE_INDICATOR: 'Indicatore di performance',
          ENPI_VALUE: 'Valore EnPI',
          ENB_VALUE: 'Valore EnB',
          SUCCESS_THRESHOLD: 'Soglia di successo (%)',
        },
      },
      companiesFields: {
        labels: {
          NAME: 'Nome',
          COUNTRY_ID: 'Paese',
          CURRENCY: 'Valuta',
          LANGUAGE: 'Lingua',
          INDUSTRY: 'Industria',
        },
      },
      assignedAction: {
        assignedTo: 'Assegnato a',
        assignedBy: 'Assegnato da',
        assignedDate: 'Data di assegnazione',
        requestReassign: 'Richiesta di riassegnazione',
        actionStatus: "Stato dell'azione",
        partsNeeded: 'Parte richiesta',
        productionOutage: 'Arresto richiesto',
        timeToRepair: 'Tempo di riparazione',
        repairCost: 'Costo di riparazione',
        closeOutRef: 'Ref. di chiusura',
        'assignmentRecord.documentId': 'ID di registro',
        assignmentId: 'ID di assegnazione',
        owner: 'Proprietario',
        companyName: 'Azienda',
        assignmentActive: "Stato dell'assegnazione",
        'assignmentRecord.leakStatus.building': 'Unità/Edificio/Macchina',
        'assignmentRecord.leakStatus.facility': 'Struttura',
        'assignmentRecord.leakStatus.routeName': 'Percorso',
        'assignmentRecord.leakStatus.smartTag': 'Etichetta intelligente n.',
        'assignmentRecord.leakStatus.workRef': 'Riferimento di lavoro n.',
        'assignmentRecord.currency': 'Valuta',
      },
      AAR_FIELD_LABEL: {
        NOTES: 'Azione intrapresa',
        CLOSE_OUT_REF: "Riferimento di chiusura dell'azione n.",
        PARTS_NEEDED: 'Nuova parte/componente richiesta',
        PRODUCTION_OUTAGE: 'Produzione interrotta',
        REPAIR_COST: 'Costo ($)',
        REQUEST_REASSIGN: 'Richiedi riassegnazione',
        ACTION_STATUS: "Stato dell'azione",
        TIME_TO_REPAIR: 'Tempo impiegato per la riparazione (minuti)',
      },
      leak: {
        chartsLabels: {
          FLOW_BY_LEAK: 'Flusso per categoria di perdita',
          LOSS_BY_LEAK: 'Perdita per categoria di perdita',
          TAGS_BY_LEAK: 'Etichette per categoria di perdita',
          AVG_FLOW_BY_LEAK: 'Flusso medio per categoria di perdita',
          SAVING_OPT_BY_REPAIR: 'Opportunità e risparmi per tempo di riparazione',
          FLOW_REPAIR_TIME: 'Flusso per tempo di riparazione',
          LOSS_REPAIR_TIME: 'Perdita per tempo di riparazione',
          FLOW_REPAIR_PROG: 'Flusso per avanzamento delle riparazioni',
          TOTAL_REPAIR_PROG: 'Perdita per avanzamento delle riparazioni',
          FLOW_BY_EQUIP_COMP: 'Flusso per attrezzatura/componente',
          LOSS_BY_EQUIP_COMP: 'Perdita per attrezzatura/componente',
          TAGS_BY_EQUIP_COMP: 'Etichette per attrezzatura/componente',
        },
        leakCategoryLabels: {
          LOW: 'Basso',
          MEDIUM: 'Medio',
          HIGH: 'Alto',
        },
        actionStatus: {
          OPEN: 'Apri',
          COMPLETE: 'Completo',
        },
        equipmentTypes: {
          CONNECTOR: 'Connettore',
          CONTROL_VALVE: 'Valvola di controllo',
          HOSE: 'Tubo flessibile',
          TUBE_FITTING: 'Raccordo per tubi',
          METER: 'Misuratore',
          OPEN_ENDED_LINE: 'Linea aperta',
          PRESSURE_RELIEF_VALVE: 'Valvola di sicurezza',
          PUMP_SEAL: 'Tenuta della pompa',
          REGULATOR: 'Regolatore',
          VALVE: 'Valvola',
          LEVEL_CONTROLLER: 'Controllore di livello',
          POSITIONER: 'Posizionatore',
          PRESSURE_CONTROLLER: 'Regolatore di pressione',
          TRANSDUCER: 'Trasduttore',
          GENERIC_PNEUMATIC_INSTRUMENT: 'Strumento pneumatico generico',
          GENERIC_RECIPROCATING_COMPRESSOR: 'Compressore alternativo generico',
          GENERIC_CENTRIFUGAL_COMPRESSOR: 'Compressore centrifugo generico',
        },
        mainGasValues: {
          AIR: 'Aria',
          METHANE: 'Metano (CH4)',
          CARBON_DIOXIDE: 'Anidride carbonica (CO2)',
          HYDROGEN: 'Idrogeno (H2)',
          HELIUM: 'Elio (He)',
          NITROGEN: 'Azoto (N2)',
          REFRIGERANT: 'Refrigerante (HFC)',
          ARGON: 'Argon (Ar)',
          OXYGEN: 'Ossigeno (O)',
          WATER: 'Acqua (Vapore)',
        },
        leakTypeValues: {
          DEFAULT: 'Nessuno selezionato',
          HOLE: 'Foro',
          CRACK: 'Crepa',
          FITTING: 'Raccordo',
          FLANGE: 'Flangia',
          'GLAND/SEAL': 'Pressacavo/Tenuta',
          THREAD: 'Filetto',
          'TUBE/HOSE': 'Tubo/Tubo flessibile',
        },
        serviceValues: {
          COMPRESSED_AIR: 'Aria compressa',
          VACUUM: 'Vuoto',
          STEAM: 'Vapore',
          PROCESS_GAS: 'Gas di processo',
          LIQUID: 'Liquido',
        },
        compressorTypesValues: {
          ROTARY_SCREW: 'Vite rotativa',
          RECIPROCATING: 'Alternativo',
          SCROLL: 'Scroll',
          CENTRIFUGAL: 'Centrifugo',
        },
        regionValues: {
          NORTH_AMERICA: 'Nord America',
          OUTSIDE_NORTH_AMERICA: 'Fuori Nord America',
        },
        locationTypeValues: {
          RESIDENTIAL: 'Residenziale',
          COMMERCIAL: 'Commerciale',
          INDUSTRIAL: 'Industriale',
          MEDIUM_VOLTAGE: 'Media Tensione',
          HIGH_VOLTAGE: 'Alta Tensione',
        },
        phaseValues: {
          SINGLE_PHASE: 'Monofase',
          THREE_PHASE: 'Trifase',
        },
        faultValues: {
          SELECT_FAULT_TYPE: 'Seleziona il tipo di guasto',
          KNICKS_OR_VOIDS_IN_INSULATION: "Tagli o vuoti nell'isolamento",
          CORONA: 'Corona',
          TREEING: 'Albero',
          TRACKING: 'Tracciamento',
          ARCING: 'Arco',
          'DIRTY_POWER/POWER_DISTORTION': 'Energia sporca/distorsione',
          MECHANICAL_LOOSENESS: 'Lassità meccanica',
          DELAMINATION_OF_WINDINGS: 'Delaminazione dei circuiti',
          LOOSE_PANEL: 'Pannello allentato',
          VIBRATING_NAMEPLATE: 'Placca oscillante',
          ANTAGONISTIC_ULTRASOUND: 'Ultrasuoni antagonisti',
          OTHER: 'Altro',
        },
        electricEquipmentTypeValues: {
          MCC: 'MCC (Controllo Motore)',
          'TRANSFORMER,_DRY': 'Trasformatore, Asciutto',
          'TRANSFORMER,_OIL': 'Trasformatore, Olio',
          SWITCH_GEAR: 'Interruttore',
          PANEL: 'Pannello',
          BUSDUCT: 'Canalizzazione',
          CABLE: 'Cavo',
          CONNECTOR: 'Connettore',
          BREAKER: 'Interruttore',
          BUSHING: 'Giunto di isolamento',
          TRANSMISSION_LINE: 'Linea di trasmissione',
          'TRANSFORMER,_POLE': 'Trasformatore, Pole',
          BATTERY: 'Batteria',
          BATTERY_BANK: 'Batteria di accumulo',
          TERMINALS: 'Terminali',
          'TRANSFORMER,_STEP_UP': 'Trasformatore, Aumenta',
          'TRANSFORMER,_STEP_DOWN': 'Trasformatore, Riduce',
          DISTRIBUTION_PANEL: 'Pannello di distribuzione',
          BREAKER_PANEL: 'Pannello del limitatore',
          RELAYS: 'Relè',
          CAPACITORS: 'Condensatori',
          REACTORS: 'Reattori',
          UPS: 'UPS',
          GROUNDING: 'Messa a terra',
          POWER_METERS: 'Contatori di energia',
          CURRENT_TRANSFORMERS: 'Trasformatori di corrente',
          POTENTIAL_TRANSFORMERS: 'Trasformatori di potenziale',
          SURGE_PROTECTION: 'Protezione da sovratensioni',
          CABLE_TRAYS: 'Canali per cavi',
          EMERGENCY_LIGHTING: 'Illuminazione di emergenza',
          CONTACTORS: 'Contattori',
          INVERTERS: 'Inverter',
          SOLAR_PANELS: 'Pannelli solari',
          BATTERY_STORAGE_SYSTEMS: 'Sistemi di accumulo delle batterie',
        },
        recordTypes: {
          leak: 'Perdita',
          electrical: 'Elettrico',
        },
        labels: {
          LOW: 'Basso',
          MEDIUM: 'Medio',
          HIGH: 'Alto',
          EQUIPMENT: 'Attrezzatura',
          SAVINGS: 'Risparmi',
          OPPORTUNITY: 'Opportunità',
          LOSS: 'Perdita',
          REPAIRED: 'Riparato',
          UNREPAIRED: 'Non riparato',
          LESS_15_DAYS: 'Meno di 15 giorni',
          DAYS_16_TO_30: '15 a 30 giorni',
          DAYS_31_TO_60: '31 a 60 giorni',
          DAYS_61_TO_90: 'Più di 60 giorni',
          LESS_THAN_15_DAYS: 'Riparato in meno di 15 giorni',
          '16_TO_30_DAYS': 'Riparato in 16-30 giorni',
          '31_TO_60_DAYS': 'Riparato in 31-60 giorni',
          MORE_THAN_60_DAYS: 'Riparato in 61-90 giorni',
          AIR: 'Aria',
          METHANE: 'Metano (CH4)',
          CARBON_DIOXIDE: 'Anidride carbonica (CO2)',
          HYDROGEN: 'Idrogeno (H2)',
          HELIUM: 'Elio (He)',
          NITROGEN: 'Azoto (N2)',
          REFRIGERANT: 'Refrigerante (HFC)',
          ARGON: 'Argon (Ar)',
          OXYGEN: 'Ossigeno (O)',
          WATER: 'Acqua (Vapore)',
          DEFAULT: 'Nessuno selezionato',
          HOLE: 'Foro',
          CRACK: 'Crepa',
          FITTING: 'Raccordo',
          FLANGE: 'Flangia',
          'GLAND/SEAL': 'Pressacavo/Tenuta',
          THREAD: 'Filetto',
          'TUBE/HOSE': 'Tubo/Tubo flessibile',
          COMPRESSED_AIR: 'Aria compressa',
          VACUUM: 'Vuoto',
          STEAM: 'Vapore',
          PROCESS_GAS: 'Gas di processo',
          LIQUID: 'Liquido',
          ROTARY_SCREW: 'Vite rotativa',
          RECIPROCATING: 'Alternativo',
          SCROLL: 'Scroll',
          CENTRIFUGAL: 'Centrifugo',
          CONNECTOR: 'Connettore',
          CONTROL_VALVE: 'Valvola di controllo',
          HOSE: 'Tubo flessibile',
          TUBE_FITTING: 'Raccordo per tubi',
          METER: 'Misuratore',
          OPEN_ENDED_LINE: 'Linea aperta',
          PRESSURE_RELIEF_VALVE: 'Valvola di sicurezza',
          PUMP_SEAL: 'Tenuta della pompa',
          REGULATOR: 'Regolatore',
          VALVE: 'Valvola',
          LEVEL_CONTROLLER: 'Controllore di livello',
          POSITIONER: 'Posizionatore',
          PRESSURE_CONTROLLER: 'Regolatore di pressione',
          TRANSDUCER: 'Trasduttore',
          GENERIC_PNEUMATIC_INSTRUMENT: 'Strumento pneumatico generico',
          GENERIC_RECIPROCATING_COMPRESSOR: 'Compressore alternativo generico',
          GENERIC_CENTRIFUGAL_COMPRESSOR: 'Compressore centrifugo generico',
        },
        leakRecordPDF: 'Registri - {{date}}',
        leakTag: 'Etichette intelligenti - {{date}}',
      },
      compressorFields: {
        labels: {
          COMPRESSOR_TAG: 'Tag del compressore',
          COMPRESSOR_TYPE: 'Tipo di compressore',
          COMPRESSOR_MAKE: 'Marca del compressore',
          COMPRESSOR_MODEL: 'Modello del compressore',
          NAMEPLATE_HP: 'HP di targa',
          NAMEPLATE_CAPACITY: 'Capacità di targa (m³/h)',
          MOTOR_EFFICIENCY: 'Efficienza del motore (%)',
          MOTOR_VOLTAGE: 'Tensione del motore',
          FULL_LOAD_CURRENT: 'Corrente a pieno carico (Ampere)',
          FULL_LOAD_INPUT_POWER: 'Potenza in ingresso a pieno carico (kW)',
          RATED_PRESSURE: 'Pressione nominale (kPag)',
          PRESSURE_SETPOINT: 'Punto di impostazione della pressione (kPag)',
          CONTROL: 'Controllo',
          TOTAL_AIR_STORAGE_SIZE: "Dimensione totale dello stoccaggio dell'aria (l)",
          IS_ACTIVE: 'Compressore Attivo / Spento',
          OPERATION_TYPE: 'Trim / Carico base',
          PERCENT_LOAD: '% Carico',
          COMPRESSOR_SETPOINT_SEU: 'Punto di impostazione del compressore (kPag)',
          COMPRESSOR_FLOW_SEU: 'Flusso del compressore (m³/h)',
          SYSTEM_PRESSURE_SETPOINT: 'Punto di impostazione della pressione del sistema (kPag)',
          SYSTEM_MEASURED_FLOW: 'Flusso misurato del sistema (m³/h)',
          DATE_TIME_RUNNING_STATE: 'Data e ora dello stato di funzionamento',
          NOTES: 'Note',
          NAMEPLATE: 'Targa del compressore',
          DATASHEET: 'Scheda tecnica del compressore',
          BHP: 'BHP',
          OPERATING_HOURS: 'Ore di funzionamento',
          LOADED_PERCENT_TIME_RUNNING: '% Tempo di funzionamento',
          LOADED_PERCENT_FULL_LOAD_BHP: '% BHP a carico pieno (Capacità)',
          UNLOADED_PERCENT_TIME_RUNNING: '% Tempo di funzionamento',
          UNLOADED_PERCENT_FULL_LOAD_BHP: '% BHP a carico pieno (Capacità)',
          ENERGY_COST: 'Tariffa elettrica aggregata ($)',
          ANNUAL_ENERGY_COST: 'Costo energetico annuale ($)',
          ANNUAL_ENERGY_KWH: 'Energia annuale in kWh',
          COST_FULLY_LOADED: 'Costo quando completamente carico ($)',
          COST_UNLOADED: 'Costo quando scarico ($)',
          KWH_PER_YEAR_LOADED: "kWh all'anno quando carico",
          KWH_PER_YEAR_UNLOADED: "kWh all'anno quando scarico",
          ENERGY_COST_PER_UNIT: '$/m³',
        },
        labelsImperial: {
          NAMEPLATE_CAPACITY: 'Capacità di targa (cfm)',
          FULL_LOAD_INPUT_POWER: 'Potenza in ingresso a pieno carico (BTU/h)',
          RATED_PRESSURE: 'Pressione nominale (psi)',
          PRESSURE_SETPOINT: 'Punto di impostazione della pressione (psi)',
          TOTAL_AIR_STORAGE_SIZE: "Dimensione totale dello stoccaggio dell'aria (gal)",
          COMPRESSOR_SETPOINT_SEU: 'Punto di impostazione del compressore (psi)',
          COMPRESSOR_FLOW_SEU: 'Flusso del compressore (cfm)',
          SYSTEM_PRESSURE_SETPOINT: 'Punto di impostazione della pressione del sistema (psi)',
          SYSTEM_MEASURED_FLOW: 'Flusso misurato del sistema (cfm)',
          ENERGY_COST_PER_UNIT: '$/cf',
        },
        labelsMetricEu: {
          NAMEPLATE_CAPACITY: 'Capacità di targa (m³/min)',
          RATED_PRESSURE: 'Pressione nominale (bar)',
          PRESSURE_SETPOINT: 'Punto di impostazione della pressione (bar)',
          COMPRESSOR_SETPOINT_SEU: 'Punto di impostazione del compressore (bar)',
          COMPRESSOR_FLOW_SEU: 'Flusso del compressore (m³/min)',
          SYSTEM_PRESSURE_SETPOINT: 'Punto di impostazione della pressione del sistema (bar)',
          SYSTEM_MEASURED_FLOW: 'Flusso misurato del sistema (m³/min)',
        },
      },
      energyFields: {
        labels: {
          UTILITY_PROVIDER: 'Fornitore di servizi',
          ENERGY_COST: '$/kWh',
          ENERGY_UNIT: 'Unità',
          REBATE_COST: '$/kWh',
          REBATE_UNIT: 'Unità',
          ENERGY_SOURCES: 'Fonti di energia',
          FE_HOURS_OPERATION: 'Ore di funzionamento',
          FE_ENERGY_COST: "Costo dell'energia ($/kWh)",
          FE_EFFICIENCY: 'Efficienza (kW/m³/h)',
          KWH_PER_FLOW: 'kWh/m³/h',
          COST_PER_FLOW: '$/m³',
        },
        labelsImperial: {
          FE_EFFICIENCY: 'Efficienza (kW/cfm)',
          KWH_PER_FLOW: 'kWh/cfm',
          COST_PER_FLOW: '$/cf',
        },
        labelsMetricEu: {
          FE_EFFICIENCY: 'Efficienza (kW/m³/min)',
          KWH_PER_FLOW: 'kWh/m³/min',
        },
      },
    },
    hooks: {
      useError: {
        message: 'Errore di validazione della richiesta. Si prega di controllare i campi del modulo',
      },
    },
    layouts: {
      dashboardLayout: {
        topBar: {
          registerADevice: 'Registrare un dispositivo',
          help: 'Aiuto',
          metric: 'Metrico',
          imperial: 'Imperiale',
          metricEu: 'Metric EU',
          downloadApk: 'Scarica APK',
          downloadOta: 'Scarica file',
        },
        otaDialog: {
          title: 'Scarica file',
          downloadButton: 'Scarica',
          serialNumberLabel: 'Numero di serie del dispositivo',
          serialNumberRequired: 'Numero di serie richiesto',
          fileDownloaded: 'File {{fileName}} scaricato con successo',
          errorFetchingFile: 'Errore durante il recupero del file. Per favore riprova più tardi',
          selectSerialNumber: 'Seleziona un numero di serie del dispositivo',
        },
        banners: {
          leakRecordsList: {
            dialogOne: 'Sei sul piano Essenziale. ',
            dialogTwo: 'Clicca ',
            dialogThree: 'qui',
            dialogFour: 'per acquistare una nuova licenza amministratore o contatta ',
            dialogFive: 'support@prosaris.ca',
          },
          serviceUnavailable:
            "Stiamo riscontrando difficoltà tecniche. Il nostro servizio potrebbe essere interessato. Ci scusiamo per l'inconveniente.",
          downForMaintenance: 'Il sistema è attualmente in manutenzione. Riprova più tardi.',
          tagsManagement: {
            question: 'Ti piacciono i tuoi PROSARIS Smart Tags?',
            purchaseLink: 'Acquista qui ulteriori Smart Tags!',
          },
        },
        mobileNav: {
          index: {
            menu: 'Menu',
            editProfile: 'Modifica profilo',
            logout: 'Esci',
          },
        },
        notifications: {
          title: 'Notifications',
          notificationsList: {
            clearAll: 'Cancella tutto',
            readAll: 'Segna tutto come letto',
            noNotifications: 'Nessuna notifica',
          },
        },
        index: {
          dashboard: 'Cruscotto',
          records: 'Record',
          actions: 'Azioni',
          company: 'Azienda',
          tags: 'Tag',
          support: 'Support',
        },
        loggedInAs: 'Connesso come',
      },
    },
    utils: {
      displayAssignedRecords: {
        cannontDeterminByField: "Impossibile determinare l'etichetta dal campo {{field}}",
        cannontDeterminByLabel: "Impossibile determinare il campo dall'etichetta {{label}}",
        active: 'Attivo',
        closed: 'Chiuso',
      },
    },
    views: {
      commonUsedWords: {
        dashboard: 'Cruscotto',
        records: 'Record',
        actions: 'Azioni',
        company: 'Azienda',
        tags: 'Tag',
        redirecting: 'Reindirizzamento in corso...',
      },
      account: {
        index: {
          updatePassword: 'Password aggiornata con successo.',
          accountDeletedSuccess: "L'account {{user}} è stato eliminato con successo",
          accountDeletedError: "Impossibile eliminare l'account al momento. Per favore riprova più tardi.",
          authenticationError: "Impossibile autenticare l'utente",
          currentPasswordIsRequired: 'È richiesta la password attuale',
          firstNameIsRequired: 'Il nome è obbligatorio',
          lastNameIsRequired: 'Il cognome è obbligatorio',
          personalDetails: 'Informazioni di base',
          changePassword: 'Reimposta password',
          currentPassword: 'Password attuale',
          profilePicture: 'Immagine del profilo',
          dangerZone: 'Zona di pericolo',
          integrations: 'Integrazioni',
          sosShipments: 'SOS Inventario',
          sosSyncMessage:
            'Questo processo attiva il processamento degli ordini SOS in Prosaris con i dati più recenti di SOS Inventario. Sebbene questo processo venga generalmente gestito automaticamente ogni 4 ore tramite un compito pianificato, usare questo pulsante ti consente di avviare il processo manualmente.',
          sosSyncSuccess: 'La sincronizzazione di SOS è stata attivata con successo',
          triggerSosSync: 'Attiva sincronizzazione SOS',
          hubspot: 'HubSpot',
          hubspotSyncMessage:
            'Questo processo spinge immediatamente gli ultimi dati della piattaforma a HubSpot. Questa sincronizzazione avviene automaticamente ogni ora tramite un compito pianificato, ma facendo clic sul pulsante è possibile avviare manualmente la sincronizzazione quando necessario.',
          hubspotSyncSuccess: 'La sincronizzazione di HubSpot è stata attivata con successo',
          triggerHubspotSync: 'Attiva sincronizzazione HubSpot',
          deleteAccountTitle: 'Elimina account',
          deleteAccountMessage: "L'account non sarà più disponibile e tutte le informazioni personali verranno eliminate permanentemente.",
          alertTitle: "Si prega di confermare l'eliminazione dell'account",
          deleteDialog: {
            dialogTwo: "L'eliminazione del tuo account rimuoverà permanentemente tutte le tue informazioni personali dal nostro database.",
            dialogThree: 'QUESTA AZIONE NON PUÒ ESSERE ANNULLATA.',
            dialogFour: 'Si prega di inserire la password per continuare.',
          },
        },
        toolBar: {
          cacheClearedSuccess: 'Cache svuotata con successo!',
          editProfile: 'Modifica profilo',
          clearCache: 'Cancella cache',
          alertTitle: "Si prega di confermare la cancellazione della cache dell'app",
          deleteAll: 'Elimina tutto',
          accordionDialog: {
            dialogOne: 'Questo eliminerà tutte le impostazioni memorizzate per le seguenti pagine:',
            dialogTwo: 'Grafici, filtri dei grafici, intervallo di tempo',
            dialogThree: 'Filtri, Ordinamento, Colonne, Anteprima',
            dialogFour: 'Filtri, colonne',
            dialogFive: 'Azienda selezionata',
            dialogSix: 'Filtri, colonne',
          },
          deleteSelective: 'Elimina selettivamente',
          selectiveDialog: 'Si prega di selezionare le impostazioni memorizzate che si desidera eliminare:',
        },
        constants: {
          Dashboard: {
            TIMEFRAME: 'Intervallo di tempo',
            CHART_FILTERS: 'Filtri dei grafici',
            CHARTS: 'Grafici',
          },
          Records: {
            HIGHLIGHTED: 'Anteprima',
            COLUMNS: 'Colonne',
            FILTERS: 'Filtri',
            SORT_COLUMN: 'Ordinamento',
          },
          Actions: {
            FILTERS: 'Filtri',
            COLUMNS: 'Colonne',
          },
          Company: {
            SELECTED: 'Azienda selezionata',
          },
          Tags: {
            FILTERS: 'Filtri',
            COLUMNS: 'Colonne',
          },
        },
      },
      assignmentsList: {
        filters: {
          companyName: 'Azienda',
          'leakStatus.building': 'Unità/Edificio/Macchina',
          'leakStatus.facility': 'Struttura',
          'leakStatus.smartTag': 'Etichetta intelligente n.',
          'leakStatus.workRef': 'Rif. di lavoro n.',
        },
        tableBody: {
          noAssignmentsToDisplay: 'Non ci sono assegnazioni da visualizzare',
        },
        filtersCommonWords: {
          recordsFilter: 'Filtro dei record',
          column: 'Colonna',
          selectAColumn: 'Seleziona una colonna...',
          addSearchTerm: 'Aggiungi un termine di ricerca...',
          filtersArentAvailable: 'I filtri non sono disponibili',
          value: 'Valore',
          exportCSV: 'Creain CSV',
          show: 'Mostra',
          loadMoreRecords: 'Carica più record',
          selectedAllRecords: 'Selezionati tutti i record ({{totalNum}})',
          selectedFromRecords: 'Selezionato {{selectedNum}} su {{totalNum}} record',
          reset: 'Ripristina',
        },
        invalidColumn: 'Colonna non valida {{column}}',
        assignedActionRecords: 'Registri delle azioni assegnate',
      },
      auth: {
        forgotPasswordView: {
          forgotYourPassword: 'Hai dimenticato la password?',
          successMessage: "Abbiamo inviato un'email di conferma a",
        },
        authSuccess: {
          thanks: 'Grazie!',
          backToLogin: 'Accedi alla piattaforma',
        },
        loginView: {
          forgotPass: 'Hai dimenticato la password?',
          createAccount: 'Crea un account',
          passwordIsRequired: 'È richiesta la password',
          resetPassword: 'Reimposta password',
          contactSupport: 'Si prega di contattare support@prosaris.ca',
          incorrectEmailOrPassword: 'Email o password errata',
          resetPassDialog: {
            dialogOne: 'È necessario reimpostare la password prima di continuare.',
            dialogTwo: 'È stata inviata una email di reimpostazione della password con istruzioni.',
          },
          ok: 'OK',
        },
        resetPasswordView: {
          passwordSuccessFullyReset: 'La password è stata reimpostata con successo',
          enterNewPassword: 'Inserisci la tua nuova password qui sotto.',
          passwordChanged: 'La tua password è stata cambiata.',
        },
        createCompanyView: {
          companyName: 'Nome dell’azienda',
          companyNameIsRequired: "Il nome dell'azienda è richiesto",
          successTitle: 'Congratulazioni! Il tuo account {{companyName}} è stato creato con successo.',
          successDescription:
            'Il tuo account aziendale è stato creato. Puoi aggiungere altri membri del team all’azienda sulla piattaforma. Per ulteriori domande, contatta {{companyEmail}}.',
          companySetup: 'Configurazione azienda',
          createCompany: 'Crea nuova azienda',
          createCompanyDescription:
            "Se la tua organizzazione è nuova sulla piattaforma {{companyName}}, puoi ora creare la tua azienda sulla piattaforma. Sarai l'amministratore dell'azienda.",
          or: 'O',
          joinExistingCompany: 'Unisciti a un’azienda esistente',
          joinExistingCompanyDescription:
            'Se la tua organizzazione ha già un account aziendale registrato sulla piattaforma {{companyName}} e desideri unirti, segui una delle due opzioni di seguito.',
          joinExistingCompanyOptions: {
            optionOne: 'Contattaci a {{supportEmail}}. Un membro del nostro team ti aggiungerà all’azienda desiderata.',
            optionTwo: 'Contatta l’amministratore dell’azienda. Possono inviarti un invito direttamente dalla piattaforma.',
          },
          essentialRoleMessage:
            'Il tuo account si trova automaticamente nel piano Essenziale. Per ulteriori informazioni sulle varie opzioni di piano di {{companyName}}, contatta {{supportEmail}}.',
          userRoleMessage: 'Inoltre, sei entrato in {{companyName}} come utente sulla piattaforma. Accedi per accedere all’azienda.',
        },
        amazonRegistration: {
          selectYourCompany: 'Seleziona la tua azienda',
          selectCompanyDescription: 'Seleziona l’azienda a cui desideri unirti.',
          searchCompanies: 'Cerca aziende...',
          finishRegistration: 'Completa',
          cantFindCompany: 'Non trovi la tua struttura?',
          cantFindCompanyStill: 'Hai bisogno di aiuto?',
          cantFindCompanyDescription:
            'Se la tua organizzazione ha già un account aziendale registrato e desideri unirti, segui una delle opzioni qui sotto.',
          cantFindCompanyOptionOne: 'Contatta <a href="mailto:{{supportEmail}}"><strong>{{supportEmail}}</strong></a>.',
          companyRequired: 'Seleziona un’azienda per continuare',
          registrationSuccess: 'Account creato con successo! Effettua l’accesso.',
          registrationError: "Creazione dell'account non riuscita. Riprova.",
          back: 'Indietro',
          addCompany: 'Aggiungi struttura',
          addCompanyTitle: 'Aggiungi nuova struttura',
          addCompanyDescription: "Crea una nuova struttura sotto un'azienda madre.",
          selectParentCompany: 'Seleziona azienda madre',
          companyName: 'Nome struttura',
          companyNamePlaceholder: 'es., YYZ1',
          companyNameHelperText: 'Inserisci un codice struttura di 3 lettere seguito da 1-2 cifre (es., YYZ1)',
          validatingAirportCode: 'Verifica codice struttura...',
          invalidAirportCode: 'Codice struttura non trovato',
          networkError: 'Errore di rete. Per favore riprova.',
          validAirportCode: '{{municipality}}, {{country}}',
          companyNameRequired: "Il nome dell'azienda è obbligatorio",
          parentCompanyRequired: "L'azienda madre è obbligatoria",
          invalidCompanyNameFormat: "Il nome dell'azienda deve essere un codice struttura seguito da 1-2 cifre (es., YYZ1, YYZ12)",
          createCompanySuccess: 'Azienda {{name}} creata con successo!',
          createCompanyError: "Impossibile creare l'azienda. Riprova.",
          cannotSelectFacility: "Impossibile creare un'azienda sotto una struttura. Seleziona un'azienda madre.",
          pendingCompanySelected: 'La nuova azienda "{{name}}" verrà creata al termine della registrazione.',
        },
      },
      calculateLeak: {
        index: {
          loadingLeakError: 'Si è verificato un errore imprevisto durante il caricamento dei dati sulla perdita',
          calculatingError: 'Si è verificato un errore imprevisto durante il calcolo',
          dbMeasured: 'Db misurato',
          calculate: 'Calcolare',
          calculating: 'Calcolo in corso...',
          outflowCoefficient: 'Coefficiente di deflusso',
          kwhPerYear: 'Kwh/anno',
        },
      },
      companies: {
        commonUsedWords: {
          assignedAdminLicenses: 'Licenze amministratore assegnate',
          company: 'Azienda',
          totalAccounts: 'Totali account',
          email: 'Email',
          name: 'Nome',
          loadCompanyUsersError: "Impossibile caricare gli utenti dell'azienda. Per favore riprova più tardi",
          activated: 'Attivato',
          deactivated: 'Disattivato',
          activating: 'Attivazione in corso',
          deactivating: 'Disattivazione in corso',
          deactivate: 'Disattiva',
          activate: 'Attiva',
          set: 'Imposta',
          youAreGoingTo: 'Stai per',
          areYouSure: 'Sei sicuro?',
          companyNameIsRequired: "Il nome dell'azienda è richiesto",
          editCompany: 'Modifica azienda',
          moveCompany: 'Sposta azienda',
          createCompany: 'Crea azienda',
          viewHistory: 'Visualizza cronologia',
          onEssentialPlan: 'Sei su un piano essenziale. Si prega di contattare support@prosaris.ca',
          exportCSV: 'Creain CSV',
        },
        hubspotTickets: {
          title: 'Progresso Onboarding',
          searchPlaceholder: 'Cerca ticket per struttura...',
          syncNow: 'Sincronizza Ora',
          syncing: 'Sincronizzazione in corso...',
          syncTooltip: 'Questo recupererà le ultime fasi della pipeline e i ticket da HubSpot',
          unmappedCompanies: 'Aziende non mappate',
          notStartedOnboarding: 'Onboarding non iniziato',
          instructions:
            'Questi sono i ticket HubSpot che non hanno strutture corrispondenti nella piattaforma PROSARIS. Per creare una mappatura, seguire i passaggi seguenti:',
          step1: 'Crea una nuova struttura nella piattaforma PROSARIS',
          step2Before: 'Fare clic sul',
          step2After: 'pulsante',
          noUnmappedTickets: 'Nessun ticket non mappato',
          noCompaniesWithoutOnboarding: 'Nessuna azienda senza onboarding',
          noTicketsInStage: 'Nessun ticket in questa fase',
          loadingPipelines: 'Caricamento pipeline...',
          loadingTickets: 'Caricamento ticket...',
          loadingCompanies: 'Caricamento aziende...',
          errorLoadingPipelines: 'Errore durante il caricamento delle pipeline',
          noPipelinesAvailable: 'Nessuna pipeline disponibile',
          noStagesAvailable: 'Nessuna fase disponibile',
          lastUpdated: 'Ultimo aggiornamento: ',
          syncSuccess: 'Dati HubSpot sincronizzati con successo',
          syncPipelineFailed: 'Sincronizzazione pipeline HubSpot non riuscita',
          syncTicketsFailed: 'Sincronizzazione ticket HubSpot non riuscita',
        },
        accounts: {
          inviteUsers: {
            title: 'Invita utenti a {{companyName}}',
            emailAddresses: 'Indirizzi email degli utenti',
            emailsRequired: 'Indirizzi email degli utenti sono richiesti',
            successMessage: 'Utenti invitati con successo',
            note: 'Inserisci gli indirizzi email degli utenti su una nuova riga o separati da una virgola.',
            tooltip: "Ogni utente riceverà un'invito per unire l'azienda.",
            invite: 'Invita',
          },
          accountDialog: {
            companyIsRequired: "L'azienda è obbligatoria",
            roleIsRequired: 'Il ruolo è obbligatorio',
            createAccountSuccessMessage: 'Account creato con successo',
            emailTakenErrorMessage: 'Un account con questa email esiste già nel sistema',
            errorWhileCreatingAccountMessage: "Errore durante la creazione dell'account. Per favore riprova più tardi.",
            changeAccountSuccessMessage: 'Account aggiornato con successo',
            errorWhileChangingAccountMessage: "Errore durante l'aggiornamento dell'account. Per favore riprova.",
            editAccount: 'Modifica account',
            createAccount: 'Crea account',
            role: 'Ruolo',
          },
          changeOwner: {
            changeOwnerMessage: 'Vuoi anche cambiare il proprietario dei record di perdita relativi a questo account?',
            no: 'No, mantieni il conto attuale',
          },
          contentCell: {
            loadAccountRolesError: "Caricamento delle informazioni sui ruoli dell'account non riuscito. Per favore riprova più tardi",
            changeRoleSuccessMessage: "L'account {{email}} ha un nuovo ruolo",
            changeRoleErrorMessage: "Errore durante l'aggiornamento del ruolo per l'account {{email}}. Per favore riprova più tardi",
            editUser: 'Modifica utente',
            adminSetPassword: 'Amministratore imposta la password',
            adminSetSubRenewalDate: 'Data di rinnovo impostata dall’amministratore',
            resetPassword: 'Reimposta la password',
            user: 'Utente',
            deleteUser: 'Elimina utente',
          },
          index: {
            noUsersToDisplay: 'Non ci sono utenti da visualizzare',
            changeStatusSuccessMessage: 'Utente {{isActive}} con successo',
            changeStatusErrorMessage: 'Errore durante {{isActive}} utente. Per favore riprova',
            changeOwnerSuccessMessage: 'I record sono stati trasferiti a un nuovo proprietario',
            changeOwnerErrorMessage: 'Impossibile trasferire i record a un nuovo proprietario. Per favore riprova più tardi',
            deleteAccountMutationSuccessMessage: "L'account {{email}} è stato eliminato con successo",
            deleteAccountMutationErrorMessage: "Impossibile eliminare l'account {{email}} al momento. Per favore riprova più tardi",
            resetAccountPassWordSuccessMessage: 'E-mail di reimpostazione della password inviata con successo',
            users: 'utenti',
            noneAvailable: 'Nessuno disponibile',
            of: 'di',
            contactSupport:
              "Si prega di contattare support@prosaris.ca per ulteriori informazioni sulle licenze amministrative dell'azienda",
            findAccount: 'Trova account',
            placeholder: 'Digita nome o email...',
            tooltip: 'È necessaria almeno una licenza amministrativa aziendale prima di poter invitare utenti',
            invite: 'Invita',
            alertDialog: {
              messageOne: "Si prega di confermare la richiesta di reimpostazione della password dell'utente",
              messageTwo: "Si prega di confermare il cambio di stato dell'account",
              messageThree: "Si prega di confermare l'eliminazione dell'account",
            },
            sendAPasswordResetEmail: "Stai per inviare un'e-mail di reimpostazione della password per il seguente account:",
            confirmMessage: 'Vuoi procedere?',
            followingAccount: 'seguente account:',
            delete: 'ELIMINA',
            userCreatedDialogTitle: "Link per il ripristino della password dell'utente inviato con successo",
            userCreatedDialogDescription:
              "All'indirizzo email dell'utente è stato inviato un link per reimpostare la password. Puoi anche copiare il link qui sotto.",
          },
          adminSetPassword: {
            changedUserPasswordSuccessMessage: "Password dell'account aggiornata con successo",
            changedUserPasswordErrorMessage: "Errore durante l'aggiornamento dell'account. Per favore riprova.",
            setNewPassword: 'Imposta nuova password',
            accountPasswordUpdated: 'Password dell’account aggiornata',
            accountPasswordUpdatedDescription:
              'La password dell’account è stata aggiornata con successo. Puoi cliccare sul pulsante qui sotto per copiare la nuova password.',
          },
          adminSetSubRenewalDate: {
            title: "Imposta la data di rinnovo dell'abbonamento",
            subRenewalDate: "Data di rinnovo dell'abbonamento",
            changedSubRenewalDateSuccessMessage: "Data di rinnovo dell'abbonamento aggiornata con successo",
            changedSubRenewalDateErrorMessage: "Errore durante l'aggiornamento dell'account. Si prega di riprovare.",
          },
          setPassword: {
            automatic: 'Genera automaticamente una password sicura',
            manual: 'Crea password manualmente',
            copyLinkInstruction: 'Potrai visualizzare e copiare la password nel passaggio successivo',
          },
          userCreatedDialog: {
            title: 'Utente creato con successo',
            description:
              "Il tuo nuovo utente può ora iniziare a utilizzare la piattaforma. L'utente riceverà anche un link via e-mail per reimpostare la password.",
            passwordCopied: 'Password copiata negli appunti',
            passwordResetLinkCopied: 'Link di reimpostazione della password copiato negli appunti',
            copyPassword: 'Copia password',
            copyPasswordResetLink: 'Copia link per reimpostare la password',
          },
          useRoleOptions: {
            notAvailable: '(non disponibile)',
            adminSeatTaken: '(il posto amministratore è occupato)',
            allSeatsAreTaken: '(tutti i {{numSeats}} posti sono occupati)',
            adminRolesTitle: 'Ruoli amministrativi',
            roles: {
              superAdmin: 'Amministratore principale',
              companyAdmin: 'Azienda (Amministratore)',
              superCompanyAdmin: 'Aziendale  (Amministratore)',
              companyRead: 'Azienda (Solo lettura)',
              superAdminRead: 'Amministratore principale (sola lettura)',
              integrator: 'Integratore',
              auditor: 'Revisore',
              user: 'Utente',
              essential: 'Prosaris Essential',
              enterpriseAdmin: 'Amministratore aziendale',
            },
            rolesDescriptions: {
              superAdmin: 'Consentito avere il pieno controllo su più aziende.',
              companyAdmin: "Consentito visualizzare, modificare e assegnare i record dell'azienda.",
              superCompanyAdmin: "Consentito avere il pieno controllo sui record e sugli utenti dell'azienda.",
              companyRead: "Consentito visualizzare i record dell'azienda in modalità sola lettura.",
              superAdminRead: 'Consentito avere accesso in sola lettura a tutte le aziende.',
              integrator: 'Consente le integrazioni di terze parti per gestire aziende e account.',
              auditor: "Per consentire l'auditing dei record di perdita.",
              user: 'Consentito creare/aggiornare/eliminare i propri record.',
              essential: 'Un ruolo con funzionalità limitate.',
              enterpriseAdmin: "Consentito avere il pieno controllo sui record e sugli utenti dell'azienda.",
            },
            nonAdminRolesTitle: 'Ruoli non amministrativi',
          },
        },
        audits: {
          index: {
            loadAuditsErrorMessage: 'Impossibile caricare le revisioni. Per favore riprova più tardi',
            audits: 'revisioni',
            noAuditsToDisplay: 'Nessuna revisione da visualizzare',
            findByAuditorEmail: "Trova per email dell'auditor",
            placeholder: "Digita email dell'auditor...",
          },
        },
        companyTabs: {
          recordLock: {
            message: 'Crea e carica una registrazione sulla piattaforma per sbloccare questa funzionalità.',
          },
          facility: {
            index: {
              facilityNameIsRequired: 'Il nome della struttura è richiesto',
              hoursYearlyIsRequired: 'Le ore totali/anno sono richieste',
              totalHoursYearly: 'Le ore totali/anno non possono superare 8760',
              invalidPhoneNumber: 'Numero di telefono non valido',
              createErrorMessage: 'Ore x Turni non possono superare le 24 ore',
              loadFacilityErrorMessage: 'Impossibile caricare la struttura. Per favore riprova più tardi',
              createFacilitySuccessMessage: 'Struttura creata con successo',
              createFacilityErrorMessage: 'Errore durante la creazione della struttura. Per favore riprova più tardi.',
              changeFacilitySuccessMessage: 'Struttura aggiornata con successo',
              changeFacilityErrorMessage: "Errore durante l'aggiornamento della struttura. Per favore riprova.",
              facilityName: 'Nome della struttura',
              abbreviation: 'Abbreviazione',
              address: 'Indirizzo',
              enterALocation: 'Inserisci una posizione',
              tooltip: "per attività di gestione dell'energia, anche approvatore del rapporto",
              energyMgtOwner: 'Proprietario della gestione energetica',
              title: 'Titolo',
              phone: 'Telefono',
              tooltipTwo: "per i rinnovi delle soluzioni e le questioni generali dell'account",
              accountOwner: "Proprietario dell'account",
              manufacturingArea: 'Area di produzione',
              size: 'Dimensione',
              unit: 'Unità',
              hoursOfOperation: 'Ore di funzionamento',
              auditFrequency: 'Frequenza di revisione',
            },
            operationHours: {
              daysPerWeek: 'Giorni/Settimana',
              shiftsPerDay: 'Turni/Giorno',
              hoursPerShift: 'Ore/Turno',
              weeksPerYear: '52 settimane/anno',
              totalHoursYearly: 'Totale = Ore/Anno',
            },
            constants: {
              constant: 'Costante',
              monthly: 'Mensile',
              threeMonth: '3 Mesi',
              fourMonth: '4 Mesi',
              sixMonth: '6 Mesi',
              nineMonth: '9 Mesi',
              annual: 'Annuale',
              sqft: 'Piedi quadrati [SQFT]',
              sqm: 'Metri quadrati [SQM]',
            },
          },
          index: {
            users: 'Utenti',
            devices: 'Dispositivi',
            facility: 'Struttura',
            energy: 'Energia',
            seu: 'SEUs - Comp.',
            enpi: 'EnPIs/EnBs',
            routes: 'Percorsi',
            audit: 'Revisioni',
            comingSoon: 'Prossimamente...',
          },
        },
        enpis: {
          index: {
            loadEnpisErrorMessage: 'Caricamento degli EnPIs fallito. Si prega di riprovare più tardi',
            createEnpisSuccessMessage: 'EnPIs creati con successo',
            createEnpisErrorMessage: 'Errore durante la creazione degli EnPIs. Si prega di riprovare più tardi.',
            changeEnpisSuccessMessage: 'EnPIs aggiornati con successo',
            changeEnpisErrorMessage: "Errore durante l'aggiornamento degli EnPIs. Si prega di riprovare.",
            showHistory: 'Mostra cronologia',
          },
        },
        changeHistory: {
          bulkOperation: "come un'operazione in blocco",
          details: 'dettagli',
          created: 'creato',
          updated: 'aggiornato',
          componentTypes: {
            enpis: 'EnPIs',
            companies: 'Aziende',
          },
          history: 'Cronologia',
          noHistory: 'Nessuna cronologia',
        },
        energy: {
          index: {
            utilProvider: 'Fornitore di servizi pubblici',
            energyUse: "Uso dell'energia e tipo di consumo",
            error: {
              loadFacility: 'Caricamento della struttura non riuscito. Riprova più tardi',
              loadEnergy: 'Caricamento dei dati energetici non riuscito. Riprova più tardi',
              loadUtilProviderLogo: 'Caricamento del logo del fornitore di servizi pubblici non riuscito. Riprova più tardi',
              createEnergy: 'Creazione dei dati energetici non riuscita. Riprova più tardi',
              createUtilProviderLogo: 'Caricamento del logo del fornitore di servizi pubblici non riuscito. Riprova più tardi',
              updateEnergy: 'Aggiornamento dei dati energetici non riuscito. Riprova più tardi',
              deleteUtilProviderLogo: 'Eliminazione del logo del fornitore di servizi pubblici non riuscita. Riprova più tardi',
            },
            success: {
              createEnergy: 'Dati energetici creati con successo',
              updateEnergy: 'Dati energetici aggiornati con successo',
            },
          },
          utilProvider: {
            index: {
              costOfEnergy: "Costo dell'energia",
              energySources: 'Fonti di energia',
              incentiveRate: 'Tasso di Incentivo',
              per: 'per',
              validations: {
                utilProviderIsRequired: 'Il fornitore di servizi pubblici è obbligatorio',
                costOfEnergyIsRequired: "Il costo dell'energia è obbligatorio",
                costOfEnergyMustBeNumber: "Il costo dell'energia deve essere un numero",
                costOfEnergyMustBeGreaterThanZero: 'Il costo energetico deve essere maggiore di 0',
                costOfRebateMustBeAtLeatZero: 'Il costo del rimborso deve essere almeno 0',
                costOfRebateMustBeNumber: 'Il costo del rimborso deve essere un numero',
              },
            },
            UtilProviderLogo: {
              error: {
                fileSize: 'La dimensione del file deve essere inferiore a 1 MB',
                preview: 'Anteprima immagine non riuscita',
              },
              logo: 'Logo',
              addLogo: 'Aggiungi logo',
              removeLogo: 'Rimuovi logo',
            },
            EnergySources: {
              energySource: 'Fonte di energia',
              percentage: 'Percentuale',
              selectEnergySource: 'Seleziona fonte di energia',
              addEnergySource: 'Aggiungi fonte di energia',
              totalPercentage: 'Percentuale totale',
              mustBeEqualTo100: '(deve essere uguale al 100%)',
              constants: {
                energySources: {
                  NATURAL_GAS: 'Gas naturale',
                  FUEL_OIL: 'Olio combustibile',
                  DIESEL: 'Diesel',
                  GASOLINE: 'Benzina',
                  PROPANE: 'Propano',
                  COAL: 'Carbone',
                  WIND: 'Vento',
                  GEOTHERMAL: 'Geotermico',
                  BIOMASS: 'Biomassa',
                  STEAM: 'Vapore',
                  COMPRESSED_AIR: 'Aria compressa',
                  CHILLED_WATER: 'Acqua refrigerata',
                  NUCLEAR: 'Nucleare',
                  HYDRO: 'Idroelettrico',
                  SOLAR: 'Solare',
                },
              },
            },
          },
          energyUse: {
            index: {
              currentCalcApproach: 'Approccio di calcolo attuale',
              currentCalcApproachMessage:
                "Questo approccio di calcolo è attualmente applicato a tutti i campi 'Costo dell'energia' per impostazione predefinita, a meno che l'utente non lo abbia sovrascritto.",
              alertTitle: 'Reimposta approccio di calcolo',
              alertMessageOne:
                "Questa azione smetterà di utilizzare l'approccio di calcolo attuale per tutti i campi 'Costo dell'energia' d'ora in poi.",
              alertMessageTwo: 'Si prega di notare che questa modifica non influirà su alcun record esistente.',
              alertMessageThree: 'Sei sicuro di voler procedere con il ripristino?',
            },
            ReportType: {
              calcApproach: 'Approccio al calcolo',
              constants: {
                calculations: {
                  FIXED: 'Efficienza fissa',
                  USDOE: 'US DoE',
                  NREL: 'NREL capitolo 22',
                },
              },
              setAsCurrent: 'Imposta come attuale',
              setAsCurrentMessage: "Questo approccio di calcolo sarà utilizzato per tutti i campi 'Costo dell'energia' d'ora in poi.",
            },
            calculations: {
              FixedEfficiency: {
                validations: {
                  efficiencyMustBeGreaterThanZero: "L'efficienza deve essere maggiore o uguale a 0",
                  efficiencyMustBeNumber: "L'efficienza deve essere un numero",
                  operationHoursMustBeGreaterThanZero: 'Le ore di funzionamento devono essere maggiori o uguali a 0',
                  operationHoursMustBeLessThan8760: 'Le ore di funzionamento devono essere inferiori a 8760',
                  operationHoursMustBeNumber: 'Le ore di funzionamento devono essere un numero',
                },
              },
              UsDoe: {
                loaded: 'Caricato',
                unloaded: 'Scaricato',
                calcSummary: 'Riepilogo del calcolo',
                currentOperatingSystems: 'Sistemi operativi attuali',
                noCompsFoundAddCompOne: 'Nessun compressore trovato. Aggiungi un compressore dalla',
                noCompsFoundAddCompTwo: 'scheda sopra.',
                help: {
                  nameplateHpPath: 'Derivato da: SEUs - Comp. → Dati di progettazione del compressore → {compressorTag} → HP di targa',
                  nameplateCapacityPath:
                    'Derivato da: SEUs - Comp. → Dati di progettazione del compressore → {compressorTag} → Capacità di targa',
                  motorEfficiencyPath:
                    'Derivato da: SEUs - Comp. → Dati di progettazione del compressore → {compressorTag} → Efficienza del motore',
                  pressureSetpointPath:
                    'Derivato da: SEUs - Comp. → Dati di progettazione del compressore → {compressorTag} → Punto di impostazione della pressione',
                  operatingHoursPath: 'Predefinito da: Struttura → Ore di funzionamento',
                  aggregateElectricRatePath: "Derivato da: Energia → Fornitore di servizi pubblici → Costo dell'energia",
                  loadedAutoFromUnloaded: 'auto da scarico',
                  unloadedAutoFromLoaded: 'auto da carico',
                },
              },
            },
          },
        },
        compressors: {
          compressorDialog: {
            plateError: 'Errore durante il caricamento della targhetta. Per favore riprova più tardi.',
            dataSheetError: 'Errore durante il caricamento della scheda tecnica. Per favore riprova più tardi.',
            createSuccess: 'Compressore {{tag}} creato',
            createError: 'Creazione del compressore non riuscita. Per favore riprova più tardi.',
            createCompressor: 'Aggiungi compressore',
            selectTemplate: 'Scegli un compressore...',
            templatesError: 'Caricamento delle ricerche dei compressori non riuscito. Riprova più tardi.',
            searchPlaceholder: 'Cerca per modello o marca... (es.: G11-100, Atlas Copco)',
            templateDescription:
              'Un compressore di tipo a vite rotativa può essere aggiunto scegliendolo dall’elenco dei compressori disponibili o compilando manualmente le informazioni. Se si seleziona un compressore dall’elenco, le restanti informazioni verranno compilate automaticamente. È sempre possibile perfezionare le informazioni in seguito. I compressori di tipo alternativo e centrifugo dovranno essere inseriti manualmente.',
            quickSelect: 'Selezione rapida',
            quickSelectDescription: 'Scegli tra le ricerche di compressori esistenti',
            basicInfo: 'Informazioni di base',
            basicInfoDescription: 'Dettagli generali di identificazione del compressore',
            technicalSpecifications: 'Specifiche tecniche',
            technicalSpecificationsDescription: 'Parametri di prestazione e operativi',
            documentation: 'Documentazione',
            documentationDescription: 'Carica file e documenti del compressore',
            compressorSpecifications: 'Specifiche del compressore',
            nameplate: 'Targhetta',
            motor: 'Motore',
            fullLoad: 'Carico completo',
            pressure: 'Pressione',
            other: 'Altro',
            compressorFiles: 'File del compressore',
            datasheetDisplayError: 'Impossibile visualizzare il file della scheda tecnica',
            datasheetProcessError: 'Impossibile elaborare il file della scheda tecnica',
          },
          compressorFile: {
            tip: 'Aggiungi file',
            removeFile: 'Rimuovi file',
            removeImage: 'Rimuovi immagine',
            title: "Si prega di confermare l'eliminazione del compressore {{prop}}",
            proceed: 'Vuoi procedere?',
          },
          compressorForm: {
            compTagIsReq: 'Il tag del compressore è richiesto',
            controlIsReq: 'Il controllo è obbligatorio',
            hpMustBeNum: 'La potenza nominale deve essere un numero',
            capMustBeNum: 'La capacità nominale deve essere un numero',
            motorEffMustBeNum: "L'efficienza del motore deve essere un numero",
            motorVoltMustBeNum: 'La tensione del motore deve essere un numero',
            loadMustBeNum: 'La corrente a pieno carico deve essere un numero',
            loadInputMustBeNum: 'La potenza in ingresso a pieno carico deve essere un numero',
            pressureMustBeNum: 'La pressione nominale deve essere un numero',
            setpointMustBeNum: 'Il punto di impostazione della pressione deve essere un numero',
            airMustBeNum: "La dimensione totale dello stoccaggio dell'aria deve essere un numero",
            addImage: 'Aggiungi immagine',
            addFile: 'Aggiungi file',
          },
          constants: {
            compressorTypes: {
              ROTARY_SCREW: 'Vite rotativa',
              RECIPROCATING: 'Alternativo',
              CENTRIFUGAL: 'Centrifugo',
            },
            rotaryScrew: {
              loadUnloadOilFree: 'Carico/Scarico – Senza olio',
              loadUnload1Gal: 'Carico/Scarico (1 gal/CFM)',
              loadUnload3Gal: 'Carico/Scarico (3 gal/CFM)',
              loadUnload5Gal: 'Carico/Scarico (5 gal/CFM)',
              loadUnload10Gal: 'Carico/Scarico (10 gal/CFM)',
              ivmWithBlowdown: 'Modulazione della valvola di aspirazione (senza scarico)',
              ivmWithoutBlowdown: 'Modulazione della valvola di aspirazione (con scarico)',
              variableDisplacement: 'Spostamento variabile',
              vsdWithUnloading: 'Azionamento a velocità variabile con scarico',
              vsdWithStopping: 'Azionamento a velocità variabile con arresto',
            },
            reciprocating: {
              reciprocatingOnOffControl: 'Controllo on/off',
              reciprocatingLoadUnload: 'Carico/Scarico',
            },
            centrifugal: {
              centrifugalInletIgv: 'IBV con scarico',
              centrifugalInletIbv: 'IGV con scarico',
            },
          },
          contentCell: {
            min: '% deve essere almeno 0',
            max: '% non può superare 100',
            max150: '% non può superare 150',
            typeError: 'Il carico deve essere una percentuale valida',
            setpointMustBeNum: 'Il setpoint del compressore deve essere un numero',
            flowMustBeNum: 'Il flusso del compressore deve essere un numero',
            pressureSetpointMustBeNum: 'Il setpoint di pressione del sistema deve essere un numero',
            measuredFlowMustBeNum: 'Il flusso misurato del sistema deve essere un numero',
            dateTime: 'Seleziona data e ora',
            active: 'ATTIVO',
            off: 'SPENTO',
            trim: 'Regolazione',
            baseLoad: 'Carico base',
          },
          index: {
            error: 'Impossibile caricare i compressori. Per favore riprova più tardi',
            nameplateError: 'Impossibile caricare la targhetta. Per favore riprova più tardi',
            dataSheetError: 'Impossibile caricare la scheda tecnica. Per favore riprova più tardi',
            changeCompSuccess: 'Compressore aggiornato con successo',
            changeCompError: "Errore durante l'aggiornamento del compressore. Per favore riprova.",
            deleteCompSuccess: 'Compressore eliminato con successo',
            deleteCompError: "Errore durante l'eliminazione del compressore. Per favore riprova.",
            createCompNameplateSuccess: 'Targhetta del compressore caricata con successo',
            createCompNameplateError: 'Errore durante il caricamento della targhetta. Per favore riprova più tardi.',
            deleteCompNameplateSuccess: 'Targhetta del compressore eliminata con successo',
            deleteCompNameplateError: "Errore durante l'eliminazione della targhetta del compressore. Per favore riprova.",
            createCompDataSheetSuccess: 'Scheda tecnica del compressore caricata con successo',
            createCompDataSheetError: 'Errore durante il caricamento della scheda tecnica. Per favore riprova più tardi.',
            deleteCompDataSheetSuccess: 'Scheda tecnica del compressore eliminata con successo',
            deleteCompDataSheetError: "Errore durante l'eliminazione della scheda tecnica del compressore. Per favore riprova.",
            changeCompanyCompSuccess: 'Dati di sistema aggiornati con successo',
            changeCompanyCompError: "Errore durante l'aggiornamento dei dati di sistema. Per favore riprova.",
            compDesignData: 'Dati di progettazione del compressore',
            comp: 'Compressori:',
            addComp: 'Aggiungi compressore',
            editCompPermission: 'È necessaria una licenza di amministratore per modificare il compressore. Si prega di contattare',
            selectOption: "Seleziona un'opzione",
            undoChanges: 'Annulla modifiche',
            selectComp: "Seleziona un compressore dall'alto.",
            noCompsFound: 'Nessun compressore trovato.',
            compRunningState: 'Stato di funzionamento del compressore',
            compRunningStateLogs: 'Compressor Running State Logs',
            hiddenCompressors: 'Hidden compressors',
            hiddenCompressorsCount: '{{count}} hidden',
            showHiddenCompressors: 'Show {{count}} deleted',
            hideHiddenCompressors: 'Hide {{count}} deleted',
            saveRunningState: 'Save running state',
            discardChanges: 'Discard changes',
            runningStateDirty: 'You have unsaved changes.',
            unsavedChangesConfirm: 'Discard your unsaved changes?',
            compressorDeleted: 'Deleted',
            snapshotHistoryEmpty: 'No earlier states yet — changes will appear here.',
            snapshotHistoryColumnTimestamp: 'Timestamp',
            snapshotHistoryColumnStatus: 'Status',
            snapshotHistoryColumnTrigger: 'Change',
            snapshotStatus: '{{active}}/{{total}} compressors active',
            snapshotGroupToday: 'Today',
            snapshotGroupYesterday: 'Yesterday',
            snapshotCurrent: 'Current',
            snapshotCurrentSubtitle: 'Live state',
            snapshotTrigger: {
              create: 'Created',
              update: 'Edited',
              delete: 'Deleted',
              companyEdit: 'System update',
              backfill: 'Initial state',
            },
            viewingSnapshotPrefix: 'Viewing snapshot from',
            returnToCurrent: 'Return to current',
            noCompsFoundAddComp: 'Nessun compressore trovato. Aggiungi un compressore dalla sezione sopra.',
            title: "Si prega di confermare l'eliminazione del compressore",
            areYouSure: 'Sei sicuro di voler',
            compressor: 'compressore',
            delete: 'eliminare',
          },
        },
        devices: {
          contentCell: {
            device: 'Dispositivo',
            usedByMultipleCompanies: 'è utilizzato da più aziende',
          },
          index: {
            noDevicesToDisplay: 'Nessun dispositivo ha registrato dati per questa azienda',
            loadingDevicesErrorMessage: "Impossibile caricare i dispositivi dell'azienda. Per favore riprova più tardi",
            changeStatusSuccessMessage: 'Dispositivo {{isActive}} con successo',
            changeStatusErrorMessage: 'Errore durante {{isActive}} dispositivo. Per favore riprova',
            devices: 'dispositivi',
            findDevice: 'Trova dispositivo',
            placeholder: 'Digita ID del dispositivo...',
            activatedOn: 'Attivato il',
            title: 'Si prega di confermare il cambio di stato del dispositivo',
          },
        },
        company: {
          deleteCompanySuccessMessage: '{{companyName}} è stato eliminato con successo',
          deleteCompanyErrorMessage: 'Eliminazione di {{companyName}} non riuscita. Per favore riprova più tardi.',
          needAdminLicense:
            'Hai bisogno di una licenza amministrativa per accedere a questa funzionalità. Si prega di contattare support@prosaris.ca',
          deleteChildCompanyFirst:
            "Impossibile eliminare l'azienda con filiali o account. Si prega di eliminare prima tutte le filiali e gli account.",
          editSettings: 'Modifica impostazioni',
          company: 'Azienda',
          createASubCompany: 'Crea una filiale per {{companyName}}',
          deleteCompany: 'Elimina azienda',
          cannotCreateChildCompanyDialog: {
            messageOne:
              'Hai raggiunto il numero massimo di aziende che possono essere create dai tuoi account Aziendale. Si prega di contattare ',
            messageTwo: 'per ulteriori dettagli.',
          },
          deleteCompanyDialog: {
            title: "Si prega di confermare l'eliminazione dell'azienda",
            delete: 'Elimina',
            deleting: 'Eliminando',
            permanentlyDeleted: 'lo rimuoverà permanentemente dal nostro database.',
            cannotBeUndone: 'QUESTA AZIONE NON PUÒ ESSERE ANNULLATA.',
          },
        },
        companyDialog: {
          industryIsRequired: "È richiesta l'industria",
          createLogoErroerMessage: "Errore durante il caricamento dell'immagine. Per favore riprova più tardi.",
          deleteLogoErrorMessage: "Errore durante l'eliminazione dell'immagine. Per favore riprova più tardi.",
          createCompanySuccessMessage: 'Azienda {{name}} creata',
          createCompanyErrorMessage: "Impossibile creare l'azienda. Per favore riprova più tardi.",
          changeCompanySuccessMessage: 'Azienda {{name}} aggiornata',
          changeCompanyErrorMessage: "Impossibile cambiare il parametro dell'azienda. Per favore riprova più tardi.",
          language: 'Lingua',
          industry: 'Industria',
          country: 'Paese',
          currency: 'Valuta',
        },
        companyLogo: {
          setImageErrorMessage: 'La dimensione del file deve essere inferiore a 1 MB',
          logo: 'Logo',
          add: 'Aggiungi',
          removeLogo: 'Rimuovi logo',
          addLogo: 'Aggiungi logo',
        },
        index: {
          loadCompaniesErrorMessage: "Impossibile caricare l'elenco delle aziende. Per favore riprova più tardi",
          loadAccountsErrorMessage: "Impossibile caricare l'elenco delle aziende. Per favore riprova più tardi",
          changeCompaniesSectionWidth: 'Cambia la larghezza della sezione delle aziende',
        },
        sidebar: {
          filterCompanies: 'Filtra aziende',
          enterAtLeastNChatacters: 'Inserisci almeno {{length}} caratteri',
          placeholder: "Inserisci il nome dell'azienda o l'indirizzo email",
          myCompany: 'La mia azienda',
          childCompanies: 'Aziende filiali',
          moreCompany: '{{count}} altra azienda',
          moreCompanies: '{{count}} altre aziende',
        },
        routes: {
          commonUsedWords: {
            equipmentNameIsRequired: "Il nome dell'attrezzatura è obbligatorio",
            equipmentLocationIsRequired: "La posizione dell'attrezzatura è obbligatoria",
            equipmentCriticalityIsRequired: "La criticità dell'attrezzatura è obbligatoria",
            equipmentDescriptionIsRequired: "La descrizione dell'attrezzatura è obbligatoria",
            name: 'Nome',
            description: 'Descrizione',
            location: 'Posizione',
            criticality: 'Criticità',
            actions: 'Azioni',
          },
          index: {
            routePlans: 'Piani di percorso',
            addRoute: 'Aggiungi percorso',
            routeRoutesExample: 'Esempio di percorsi',
            pieceOfEquipment: '{{count}} pezzo di attrezzatura',
            piecesOfEquipment: '{{count}} pezzi di attrezzatura',
            equipment: 'Attrezzatura',
            metrics: 'Metriche',
            settings: 'Impostazioni',
            noFloorPlan: 'Non hai caricato una planimetria per questo percorso',
            addFloorPlan: 'Aggiungi una planimetria per iniziare a pianificare visivamente il tuo percorso',
            routeEquipment: 'Attrezzatura del percorso',
            routeMetrics: 'Metriche del percorso',
            metricsForRoute: 'Metriche per il percorso',
            totalRecords: ' Record totali',
            totalOpenRecords: 'Record totali aperti',
            totalClosedRecords: 'Record totali chiusi',
            totalLossPerYear: "Perdita totale all'anno",
            totalKwhPerYear: "kWh totali all'anno",
            routeUpdatedSuccessfully: 'Percorso aggiornato con successo',
            routeRemovedSuccessfully: 'Percorso rimosso con successo',
            routeSettings: 'Impostazioni del Percorso',
            removeRoute: 'Rimuovi Percorso',
            deleteRouteWarning:
              'La rimozione di questo percorso eliminerà il percorso, le attrezzature del percorso e la cronologia dal sistema, ma lascerà intatti i dati storici associati ai record.',
            areYouSure: 'Sei sicuro di voler rimuovere questo percorso?',
            warningRemovingRoute:
              'La rimozione del percorso eliminerà in modo permanente il percorso, le attrezzature e la cronologia dal sistema.',
            thisActionCannotBeUndone: 'QUESTA AZIONE NON PUÒ ESSERE ANNULLATA.',
            noFacility: 'Non hai definito nessuna struttura',
            createAFacility: 'Crea una struttura per iniziare a pianificare i percorsi',
            goToCreateAFacility: 'Vai a creare una struttura',
            createAFacilityTooltip: 'È necessario creare una struttura prima di poter iniziare a pianificare i percorsi.',
          },
          routeBuilder: {
            title: 'Costruttore di Percorsi',
            missingFields: 'Campi mancanti nel file caricato',
            facility: 'Struttura',
            route: 'Percorso',
            enterRoute: 'Inserisci il percorso',
            addFloorplan: 'Aggiungi planimetria',
            floorplanInstructionsTooltip:
              'Aggiungi un’immagine della planimetria per aiutarti a costruire i percorsi. Il percorso verrà sovrapposto alla planimetria al momento del salvataggio.',
            change: 'Cambia',
            location: 'Posizione',
            enterLocation: 'Inserisci la posizione',
            equipment: 'Attrezzatura',
            enterEquipment: 'Inserisci l’attrezzatura',
            criticality: 'Criticità',
            enterCriticality: 'Inserisci la criticità',
            description: 'Descrizione',
            enterDescription: 'Inserisci la descrizione',
            addEquipment: 'Aggiungi attrezzatura',
            addRoute: 'Aggiungi percorso',
            downloadTemplate: 'Scarica modello',
            excelTemplate: 'Modello Excel (.xlsx)',
            csvTemplate: 'Modello CSV (.csv)',
          },
          fileReader: {
            loadFromFile: 'Carica da file',
            instructionsTooltip:
              'È possibile importare le attrezzature caricando un file Excel (.xlsx, .xls) o CSV (.csv). Il file deve contenere le colonne: equipment_name, equipment_location, equipment_criticality, equipment_description. Scarica il modello fornito per iniziare.',
          },
          addRouteModal: {
            routeNameTooltip: 'Qual è il nome del percorso?',
            equipmentNameTooltip: 'Nome di questa attrezzatura',
            equipmentDescriptionTooltip: 'Descrivi questa attrezzatura',
            placeholders: {
              routeName: 'es. Percorso sala compressori',
              routeLocation: 'es. Edificio A, ala nord',
              equipmentName: 'es. Compressore 1',
              equipmentDescription: 'es. compressore, essiccatore, raccordi pneumatici',
            },
            addRouteFor: 'Aggiungi percorso per {{facilityName}}',
            giveYourNewRouteAName:
              'Dai un nome al tuo nuovo percorso, descrivi la sua posizione nella struttura e aggiungi il primo pezzo di attrezzatura',
            routeNameIsRequired: 'Il nome del percorso è obbligatorio',
            routeLocationIsRequired: 'La posizione del percorso è obbligatoria',
            routeName: 'Nome del percorso',
            routeLocation: 'Posizione del percorso',
            firstPieceOfEquipment: 'Primo pezzo di attrezzatura',
            equipmentName: "Nome dell'attrezzatura",
            equipmentCriticality: "Criticità dell'attrezzatura",
            equipmentLocation: "Posizione dell'attrezzatura",
            equipmentDescription: "Descrizione dell'attrezzatura",
            locationTooltip: "Spiega dove è posizionato nell'impianto",
            equipmentLocationTooltip: 'Spiega dove è posizionato nel percorso',
            criticalityTooltip: "Assegna una valutazione di criticità dell'attrezzatura (ECR), solitamente un valore tra 1 e 5",
            downloadTemplate: 'Scarica modello',
            downloadCsvTemplate: 'Scarica modello CSV',
            downloadExcelTemplate: 'Scarica modello Excel',
            manual: 'Manuale',
            import: 'Importa',
            importedEquipments: 'Attrezzature importate',
            pleaseImportEquipment: 'Importa le attrezzature o passa alla modalità manuale',
            equipmentOrderNote: 'Le attrezzature verranno aggiunte al percorso nello stesso ordine in cui appaiono nel file.',
            addFloorplan: 'Aggiungi piantina',
            change: 'Modifica',
            floorplan: 'Piantina',
            noValidEquipmentDataFound: 'Dati delle attrezzature non validi trovati nel file. Fare riferimento al modello.',
            equipmentItemsImportedSuccessfully: '{{count}} elementi importati con successo',
            invalidFileFormat: 'Formato file non valido. Usa il modello fornito.',
            floorplanUploadedSuccessfully: 'Piantina caricata con successo',
            routeCreatedSuccessfully: 'Percorso creato con successo',
            equipment: 'Attrezzatura',
            equipments: 'Attrezzature',
            addEquipmentBefore: 'Aggiungi attrezzatura prima',
            addEquipmentAfter: 'Aggiungi attrezzatura dopo',
            addEquipmentBetween: 'Aggiungi attrezzatura tra',
            removeEquipment: 'Rimuovi attrezzatura',
            floorplanIsRequired: 'È richiesta una piantina',
          },
          routeViewer: {
            showLabels: 'Mostra etichette',
            hideLabels: 'Nascondi etichette',
            showNumbers: 'Mostra numeri',
            hideNumbers: 'Nascondi numeri',
            markerSize: 'Dimensione marcatore',
            routeOpacity: 'Opacità del percorso',
            zoomIn: 'Ingrandisci',
            zoomOut: 'Rimpicciolisci',
            resetZoom: 'Ripristina zoom',
            centerView: 'Centra vista',
            panUp: 'Su',
            panDown: 'Giù',
            panLeft: 'Sinistra',
            panRight: 'Destra',
            expandControls: 'Mostra controlli',
            collapseControls: 'Nascondi controlli',
          },
          routeEditorAddEquipmentAction: {
            addingNewEquipment: "Aggiungere un nuovo apparecchio lo aggiunge al percorso dopo l'apparecchio selezionato.",
            addEquipment: 'Aggiungi apparecchio',
          },
          routeEditorAddWaypointAction: {
            waypoint: 'Punto di passaggio',
            addingNewWaypoint:
              "L'aggiunta di un nuovo punto di passaggio cambia la direzione del percorso dopo l'apparecchio selezionato, ma non è un passaggio durante l'esecuzione del percorso.",
            addWaypoint: 'Aggiungi punto di passaggio',
          },
          routeEditorEditEquipmentAction: {
            updateEquipment: 'Aggiorna attrezzatura',
          },
          routeEditorEditFloorPlan: {
            floorPlan: 'Piantina',
            chooseFloorplan: 'Scegli una piantina',
          },
          routeEditorModal: {
            successRouteUpdated: 'Percorso aggiornato con successo',
            errorRouteUpdated: "Errore nell'aggiornamento del percorso. Riprova più tardi.",
            successRouteDeleted: 'Percorso eliminato con successo',
            errorRouteDeleted: "Errore nell'eliminazione del percorso. Riprova più tardi.",
            successFloorplanUpdated: 'Piantina aggiornata con successo',
            errorFloorplanUpdated: "Errore nell'aggiornamento della piantina. Riprova più tardi.",
            unsavedChanges: 'Hai modifiche non salvate. Sei sicuro di voler uscire?',
            back: 'Indietro',
            editEquipment: 'Modifica attrezzatura',
            youHaventUploadedFloorPlan: 'Non hai caricato una piantina. Sblocca la modifica visiva caricandone una oggi stesso.',
            addFloorPlan: 'Aggiungi piantina',
            addNewEquipment: 'Aggiungi nuova attrezzatura',
            removeEquipment: 'Rimuovi attrezzatura',
            swapEquipment: 'Scambia attrezzatura',
            addWaypoint: 'Aggiungi punto di riferimento',
            changeFloorplan: 'Cambia piantina',
            actions: {
              ADD_EQUIPMENT: 'Aggiungi attrezzatura',
              DELETE_NODE: 'Rimuovi nodo',
              SWAP_EQUIPMENT: 'Scambia attrezzatura',
              ADD_WAYPOINT: 'Aggiungi punto di riferimento',
              CHANGE_FLOORPLAN: 'Cambia piantina',
            },
          },
          routeEditorRemoveEquipmentAction: {
            youAreAboutToRemoveEquipmentFromTheRoute: 'Stai per rimuovere la seguente attrezzatura dal percorso.',
            youAreAboutToRemoveWaypointFromTheRoute: 'Stai per rimuovere il punto di passaggio selezionato dal percorso.',
            youWillNotLoseAnyHistoricalData:
              'Non perderai alcun dato storico, ma questo {{type}} verrà rimosso dal percorso e non sarà disponibile per le future esecuzioni.',
            equipment: 'attrezzatura',
            waypoint: 'punto di passaggio',
          },
          routeEditorSwapEquipmentAction: {
            replacementEquipmentIsRequired: 'È necessario un attrezzatura di ricambio',
            swappingEquipmentExplanation: "Lo scambio di attrezzature cambia la posizione dell'attrezzatura selezionata con un'altra.",
            swappingEquipmentCaption: "Questo non influisce sui dati storici, ma cambierà l'ordine dell'attrezzatura sul percorso.",
            selectedEquipment: 'Attrezzatura selezionata',
            swapWith: 'Scambia con',
            selectEquipment: 'Seleziona attrezzatura',
            swapEquipment: 'Scambia attrezzatura',
          },
        },
      },
      companySettings: {
        settings: {
          adminLicenses: {
            aal: 'Licenze amministratore assegnate',
            of: 'di',
            edit: 'Modifica',
          },
          essentialMode: {
            disable: 'disabilita',
            enable: 'abilita',
            essential: 'Modalità essenziale:',
            enabled: 'ABILITATO',
            disabled: 'DISABILITATO',
            moveCompany: "Sposta l'azienda {{company}} in modalità essenziale",
            affectedCompanies: 'Numero di aziende interessate',
            affectedAccounts: 'Numero di account interessati',
            archivedLeak: 'Numero di record di eventi di perdita archiviati',
            applyingChanges:
              'Applicando queste modifiche, gli account otterranno il ruolo "Essenziale". Gli utenti potranno vedere {{quota}} record di eventi di perdita più recenti su un dashboard e un\'app mobile. Altri record verranno archiviati.',
            essentialLabel: 'Cambia modalità essenziale per le sottoaziende',
            turnOffEssential: "Disattiva modalità essenziale per l'azienda {{company}}",
            byApplyingChanges:
              'Applicando queste modifiche, tutti gli account otterranno il ruolo "Utente". Gli utenti potranno vedere tutti i loro record. Tutti i record verranno desarchiviati.',
          },
          hubspotSync: {
            disable: 'disabilita',
            enable: 'abilita',
            hubspot: 'Sincronizzazione HubSpot',
            enabled: 'ABILITATO',
            disabled: 'DISABILITATO',
            enableHubspotSync: "Abilita la sincronizzazione HubSpot per l'azienda {{company}}",
            disableHubspotSync: "Disabilita la sincronizzazione HubSpot per l'azienda {{company}}",
            affectedCompanies: 'Numero di aziende interessate',
            applyingChanges: 'Applicando queste modifiche, la sincronizzazione HubSpot sarà {{status}}.',
            hubspotLabel: 'Modifica la sincronizzazione HubSpot per le sottoaziende',
          },
          convertToSuperCompany: {
            title: 'Ristruttura azienda',
            newParentCompany: 'Nuova azienda principale',
            confirmChange: 'Conferma nuova struttura aziendale',
            confirmChangeMessage: 'Sei sicuro di voler convertire {{child}} come azienda secondaria di {{parent}}?',
            convertSuccess: 'Azienda ristrutturata con successo',
            convertError: "Errore nella ristrutturazione dell'azienda. Per favore riprova più tardi.",
          },
          deploymentTransfer: {
            title: 'Trasferisci Azienda',
            senderTab: 'Origine',
            receiverTab: 'Destinazione',
            configured: 'Configurato',
            checkConfiguration: 'Verifica Configurazione',
            configuredFrom: 'Configurazione di trasferimento ereditata dalla società madre',
            errorBoundary: 'Si è verificato un errore durante il caricamento del trasferimento azienda.',
            sender: {
              notConfigured: 'Non configurato',
              awaitingConnection: 'In attesa di connessione',
              awaitingS3Config: 'Configurazione S3 richiesta',
              title: 'Configurazione Origine',
              description: 'Configura questa distribuzione come origine del trasferimento dati.',
              stepOne: 'Passo 1: Configura URL di destinazione',
              stepOneDescription: 'Inserisci l’URL della distribuzione di destinazione.',
              stepTwo: 'Passo 2: Condividi chiave API',
              stepTwoDescription: 'Copia e condividi questa chiave API.',
              stepThree: 'Passo 3: Migrazione asset S3',
              stepThreeDescription: 'Configura la migrazione degli asset S3.',
              apiKey: 'Chiave API',
              copyKey: 'Copia chiave API',
              regenerateKey: 'Rigenera chiave API',
              keyCopied: 'Chiave API copiata',
              keyRegenerated: 'Chiave API rigenerata con successo',
              connected: 'Connesso alla destinazione',
              connectedTo: 'Connesso all’azienda: {{companyId}}',
              notConnectedWarning: 'Avviso: non connesso.',
              targetUrl: 'URL di destinazione',
              lambdaFunction: 'Nome funzione Lambda',
              bucketAutoConfig: 'I bucket vengono configurati automaticamente.',
              saveSuccess: 'Configurazione origine salvata',
              saveError: 'Errore nel salvataggio della configurazione origine',
              regenerateError: 'Errore nella rigenerazione della chiave API',
              deleteConfig: 'Elimina configurazione',
              deleteConfirmMessage: 'Questa azione eliminerà la configurazione origine.',
              deleteSuccess: 'Configurazione origine eliminata',
              deleteError: 'Errore durante l’eliminazione',
            },
            receiver: {
              notConfigured: 'Non configurato',
              title: 'Configurazione Destinazione',
              description: 'Configura questa distribuzione come destinazione del trasferimento.',
              sourceUrl: 'URL di origine',
              apiKey: 'Chiave API',
              apiKeyPlaceholder: 'Incolla la chiave API a 64 caratteri',
              invalidApiKey: 'La chiave API deve essere di 64 caratteri',
              connected: 'Connesso',
              pending: 'In attesa',
              connectedFrom: 'Connesso dall’azienda: {{companyId}}',
              saveAndConnect: 'Salva e connetti',
              connectionSuccess: 'Connessione riuscita',
              handshakePending: 'Configurazione salvata. In attesa di handshake.',
              saveError: 'Errore nel salvataggio',
              deleteConfig: 'Elimina configurazione',
              deleteConfirmMessage: 'Questa azione eliminerà la configurazione di destinazione.',
              deleteSuccess: 'Configurazione destinazione eliminata',
              deleteError: 'Errore durante l’eliminazione',
            },
            operations: {
              title: 'Operazioni di Trasferimento',
              description: 'Trasferisci dati e asset verso il deployment di destinazione.',
              notConnected: 'Avviso: Non connesso al deployment di destinazione.',
              stepTransferData: 'Passaggio 1: Trasferisci Dati',
              stepTransferAssets: 'Passaggio 2: Trasferisci Asset',
              transferComplete: 'Trasferimento Completato',
              completed: 'Completato',
              inProgress: 'In Corso',
              notStarted: 'Non Avviato',
              pending: 'In Sospeso',
              transferAll: 'Trasferisci Tutte le Collezioni',
              refreshStatus: 'Aggiorna Stato',
              migrateS3: 'Migra Asset S3',
              transferStarted: 'Trasferimento avviato con successo',
              transferError: 'Errore durante l’avvio del trasferimento',
              s3MigrationStarted: 'Migrazione asset S3 avviata',
              s3MigrationError: 'Errore nella migrazione asset S3',
              overallStatus: 'Stato Generale',
              totalDuration: 'Durata Totale',
              completedAt: 'Completato il',
              initiatedBy: 'Iniziato da',
              collection: 'Collezione',
              status: 'Stato',
              documents: 'Documenti',
              duration: 'Durata',
              assetType: 'Tipo di Asset',
              documentsProcessed: 'Documenti Elaborati',
              parentTransferDescription: 'Tutte le società madri devono completare il trasferimento prima di questa società.',
            },
          },
          index: 'Impostazioni',
        },
        index: {
          loadCompanyError: "Impossibile caricare le informazioni sull'azienda. Per favore riprova più tardi",
          companySlug: 'Alias aziendale',
          notSelected: 'Non selezionato',
          country: 'Paese',
          accounts: 'Account',
          currency: 'Valuta',
          adminLicenses: 'Licenze amministratore',
          totalCustomer: "Numero totale di account clienti nell'albero",
        },
      },
      device: {
        registerDeviceView: {
          registerDevice: 'Registra il tuo dispositivo',
          toolTip: 'Si prega di localizzare il numero di serie sulla sua carta di registrazione o sulla scatola.',
          serialNumberIsRequired: 'È richiesto il numero di serie',
          oops: 'Ops!',
          deviceNotFound: 'Numero di serie del dispositivo non trovato',
          deviceFoundNdAssociatedCompany: "Il tuo dispositivo è stato trovato ed è associato a un'azienda.",
          deviceFound: 'Il tuo dispositivo è stato trovato.',
          goToLogin: 'Vai al login',
          contactSupport: 'Si prega di contattare il supporto',
        },
        deviceErrorCodes: {
          'B13:001': 'Numero di serie del dispositivo non trovato',
          'B13:002': 'Dispositivo già attivato',
          'B13:003': 'Email amministratore non inviata',
          'B13:004': 'Azienda non trovata',
          'B13:005': 'Azienda non valida',
          'B13:006': 'Tipo non valido',
        },
        registerAccountView: {
          createAccountSuccess: 'Account creato con successo',
          createAccountError: "Errore durante la creazione dell'account. Per favore, contattare support@prosaris.ca",
          registerAccount: 'Crea un account',
          termsMustBeAccepted: 'È necessario accettare i termini e le condizioni.',
          saleType012Success: 'Puoi accedere per iniziare a utilizzare il tuo dispositivo.',
          saleType3Success: 'Sei stato aggiunto come utente base. Gli amministratori della tua azienda sono stati informati.',
          saleType4Success: {
            companyPlatformFound: 'Licenza della piattaforma aziendale trovata.',
            dialogOne: 'Questo dispositivo è associato a una nuova licenza della piattaforma aziendale.',
            dialogTwo: 'La tua azienda potrebbe già esistere nel nostro sistema.',
            dialogThree: 'In tal caso, contatta il tuo amministratore.',
          },
          termsAndConditions: {
            dialogOne: 'Accetto i',
            dialogTwo: 'Termini di Servizio',
            dialogThree:
              'di Prosaris e confermo di aver avuto abbastanza tempo per leggerli e capire che contengono termini importanti riguardo il mio uso del software Prosaris, come la limitazione della responsabilità di Prosaris e come saranno gestiti i miei dati.',
          },
          termsOfServiceModal: {
            termsOfService: 'Termini di servizio',
          },
          acceptTerms: 'Accetta i termini',
          registerAccountErrorCodes: {
            'B02:001': 'Codice di registrazione non valido',
            'B02:002': 'Azienda utente non valida',
            'B02:003': 'Ruolo utente non valido',
            'B02:004': "L'email è già in uso",
            'B02:005': "L'email è già in uso",
            'B02:006': 'Impossibile reimpostare la password per il tuo account',
            'B02:007': 'Azienda utente non valida',
            'B02:008': 'Foto profilo mancante',
            'B02:009': "È richiesto il reset dell'account. Il processo è stato avviato",
            'B02:010': "L'account è stato disattivato",
            'B02:011': 'Formato foto profilo non valido',
            'B02:012': "Dispositivo già registrato a un'azienda",
            'B02:013': 'Numero di serie non definito',
            'B02:014': 'Tipo non valido',
            'B02:015': 'Link per reimpostare la password scaduto',
            'B02:016': 'Non è possibile creare un account per questa azienda',
            'B02:017': 'Ruolo non valido',
            'B02:018': 'Ruolo non valido',
            'B02:019': 'Azienda utente non valida',
            'B02:020': 'Ruolo utente non valido',
            'B02:021': "L'utente non appartiene a questa azienda",
          },
          whichProduct: 'Qual è il tuo prodotto?',
        },
        devicesView: {
          serialNumbersIsReq: 'Sono richiesti i numeri di serie',
          failedToCopy: 'Numeri di serie non riusciti copiati negli appunti',
          invalidFormat: 'Uno o più dispositivi hanno un formato non valido. Si prega di controllare e riprovare.',
          devices: 'Registra i tuoi dispositivi',
          deviceSerialNumber: 'Numero(i) di serie del dispositivo',
          note: 'Inserisci ogni numero di serie su una nuova riga o separato da una virgola.',
          title: 'Si prega di individuare il numero di serie sulla carta di registrazione o sulla scatola.',
          register: 'Registrare',
          deviceRegistrationStatus: 'Stato di registrazione del dispositivo',
          success: 'Successo',
          noDeviceFound: 'Nessun dispositivo trovato.',
          failed: 'Fallito',
          copyFailed: 'Copia i numeri di serie non riusciti negli appunti',
        },
      },
      errors: {
        notFoundView: {
          title: 'La pagina che stai cercando non è qui',
          description:
            'O hai provato una scorciatoia sospetta o sei arrivato qui per errore. Qualunque sia il caso, prova a usare la navigazione.',
        },
        accountNotFound: {
          title: 'Account non trovato',
          description:
            "Per favore riprova! Se il problema persiste, il tuo account potrebbe essere inattivo o non essere stato inizializzato dall'amministratore. Si prega di contattare l'amministratore.",
          logout: 'Disconnetti',
        },
      },
      integration: {
        index: {
          loggingInError: "Errore durante l'accesso a Prosaris.",
        },
      },
      leakRecordDetails: {
        assignedActions: {
          actionImages: 'Nessuna immagine disponibile',
          activeActionRecord: {
            updateAssignmentSuccess: "L'azione assegnata è stata aggiornata.",
            updateAssignmentError: "Errore durante l'aggiornamento dell'azione assegnata.",
            deleteImageSuccess: "L'immagine assegnata è stata eliminata.",
            deleteImageError: "Errore durante l'eliminazione dell'immagine dell'azione assegnata.",
            confirmMarkAction:
              'Completando questa assegnazione, il record verrà contrassegnato come completato e tutte le azioni associate diventeranno inattive. Sei sicuro di voler continuare?',
            confirmDeleteImage: 'Vuoi davvero eliminare questa immagine?',
          },
          index: 'Errore durante il caricamento delle azioni assegnate per un record.',
        },
        audio: {
          noAudioAvailable: 'Nessun dato audio disponibile',
          errorDownloadingAudio: "Errore durante il download dell'audio. Riprova più tardi.",
          playPause: 'Riproduci / Pausa',
          generateRegion: 'Genera Regione',
          removeLastRegion: "Rimuovi l'Ultima Regione",
          generateMarker: 'Genera Marcatore',
          removeLastMarker: "Rimuovi l'Ultimo Marcatore",
          toggleTimeline: 'Attiva / Disattiva la Timeline',
          download: 'Scarica',
        },
        audit: {
          updateAuditSuccess: 'Audit aggiornato con successo',
          updateAuditError: 'Errore durante il salvataggio del commento. Per favore riprova più tardi.',
          createAuditSuccess: 'Audit creato con successo',
          createAuditError: "Errore durante la creazione dell'audit. Per favore riprova più tardi.",
          deleteAuditSuccess: "L'audit è stato eliminato con successo",
          deleteAuditError: "Impossibile eliminare l'audit. Per favore riprova più tardi.",
          noComment: 'Nessun commento',
          reviewComments: 'Commenti di revisione',
          reviewedBy: 'Esaminato da:',
          auditDate: "Data dell'audit:",
          deleteAudit: 'Elimina audit',
          reviewedNoComments: 'Esaminato nessun commento',
          auditComments: "Commenti dell'audit",
          saveComment: 'Salva commento',
          discardChanges: 'Annulla modifiche',
        },
        changeHistory: {
          created: 'creato',
          updated: 'aggiornato',
          deleted: 'eliminato',
          transferred: 'trasferito',
          synced: 'sincronizzato',
          leak: 'Registrazione',
          images: 'Immagine',
          audit: 'Audit',
          audio: 'Audio',
          history: 'Cronologia',
          noHistory: 'Nessuna cronologia',
          bulk: 'come operazione in blocco',
          details: 'dettagli',
          unset: 'non impostato',
        },
        fft: {
          fft: 'FFT (Trasformata Rapida di Fourier)',
          fftAvg: 'Media FFT',
          notApplicable: 'Non applicabile',
          chartLayers: 'Strati del grafico',
          avg: 'Media',
          all: 'Tutto',
          playing: 'Riproduzione in corso...',
          showTimeSeries: 'Mostra serie temporale',
          xAxis: 'Frequenza (Hz)',
          yAxis: 'Magnitudine',
          frame: 'Fotogramma',
          speed: 'Velocità',
          play: 'Riproduci',
          pause: 'Pausa',
          resetZoom: 'Ripristina zoom',
        },
        form: {
          updateLeakSuccess: 'Aggiornato con successo.',
          updateLeakError: "Errore durante l'aggiornamento della perdita. Per favore riprova più tardi.",
          alertTitle: {
            partOne: 'Il registro è in',
            partTwo: 'modalità sola lettura',
            partThree: '.',
          },
          alertDialog: {
            dialogOne: 'Tuttavia, è possibile modificare le seguenti proprietà:',
            dialogTwo: "Stato dell'azione",
          },
          GPSLocation: 'Posizione GPS',
          completedOn: 'Completato il:',
          lastSaved: 'Ultimo salvataggio:',
          updateConfirmMessage: 'Completare questo record renderà inattive tutte le azioni associate. Sei sicuro di voler continuare?',
          updateConfirmTitle: 'Conferma completamento del record',
          smartTagHelp: 'Scopri di più sui tag intelligenti di Prosaris',
        },
        images: {
          removeSuccess: 'Immagine eliminata con successo.',
          removeError: "Impossibile eliminare l'immagine del record di perdita. Per favore riprova più tardi.",
          text: 'Sei sicuro di voler eliminare questa immagine?',
          addImages: 'Aggiungi immagini',
          additionalImages: 'Immagini Aggiuntive',
          noAdditionalImages: 'Nessuna immagine aggiuntiva',
          uploadSuccess: 'Immagine/i caricata/e con successo.',
          uploadError: "Impossibile caricare l'immagine. Riprova più tardi.",
          maxImagesReached: 'Massimo 10 immagini aggiuntive per record.',
          tooManyFiles: 'Impossibile aggiungere {{count}} immagini. Solo altre {{remaining}} consentite.',
        },
        index: {
          title: 'Registro',
          loadingError: 'Errore durante il caricamento del record di perdita. Per favore riprova.',
          unsavedMessage: 'Premendo "Ok" confermi che tutte le modifiche non salvate verranno eliminate',
          notAnAuditor: 'Non sei un revisore',
          anEssential: 'Sei su un piano essenziale',
          showHistory: 'Mostra cronologia',
        },
        massFlow: {
          recalculating: 'Ricalcolo di flusso/perdita secondo le impostazioni del parametro di perdita...',
          warning:
            'I valori di input sono cambiati o il calcolo è obsoleto, premere "Ricalcola" per aggiornare i valori di flusso e perdita',
          calculatingError: 'Errore durante il calcolo del flusso di massa. Per favore riprova.',
          noValue: 'Nessun valore',
          calculatingSuccess: 'Flusso/Perdita ricalcolato',
          recalculate: 'Ricalcola',
          calculatorVersion: 'Versione del calcolo:',
          noteDialog: {
            dialogOne: 'Cambiare le impostazioni del parametro di perdita aggiornerà il calcolo di flusso/perdita. Controlla',
            dialogTwo: 'Approfondimenti sui calcoli',
            dialogThree: 'pagina per ulteriori informazioni',
          },
        },
        unsavedWarningDialog: {
          recordChanged: 'Il registro è stato modificato',
          close: 'Chiudi',
          unsavedChanges:
            'Questo record ha modifiche non salvate. Si prega di considerare di salvare queste modifiche o di rimuoverle completamente.',
          discardChanges: 'Annulla modifiche',
        },
      },
      leakRecordCreate: {
        form: {
          deviceIDIsRequired: "È richiesto l'ID del dispositivo",
          dbPeakIsRequired: 'È richiesto il DB di picco misurato',
          dbMin: 'Il DB di picco misurato deve essere maggiore o uguale a 0',
          dbMax: 'Il DB di picco misurato deve essere minore o uguale a 95',
          dbError: 'Il DB di picco misurato deve essere un numero',
          imageUploadError: "Errore durante il caricamento dell'immagine. Per favore riprova più tardi.",
          createLeakSuccess: 'Record aggiunto con successo',
          createLeakError: 'Errore durante la creazione di un record. Si prega di riprovare più tardi.',
          basicInfo: 'Informazioni di base',
          flowInput: 'Ingresso di flusso',
          mainGas: 'Gas/Componente principale di interesse',
          selectComponent: 'Seleziona componente',
          selectLeakType: 'Seleziona tipo di perdita',
          mightBeSomethingHere: 'non ancora sicuro',
          energyLoss: 'Perdita di energia',
          selectCompressorType: 'Seleziona tipo di compressore',
          noRoutes: 'Nessun percorso trovato',
          noEquipment: 'Nessuna attrezzatura trovata',
          noRouteEquipment: 'Nessuna attrezzatura di percorso trovata',
          routeEquipmentInfo: "Dettagli dell'attrezzatura di percorso",
          noLocations: 'Nessuna posizione trovata',
          energyCost: 'Costo energetico',
          audioRecording: 'Registrazione Audio',
          leakSourceEquipment: 'Fonte',
          selectComponentType: 'Seleziona tipo di componente',
          selectService: 'Seleziona servizio',
          locationAndUser: 'Posizione e utente',
          leakEventStatus: "Stato dell'evento",
          low: 'Basso',
          medium: 'Medio',
          high: 'Alto',
          open: 'Apri',
          complete: 'Completo',
          reset: 'Reimposta',
        },
        formElectrical: {
          systemVoltages: 'Tensioni di sistema',
          source: 'Fonte',
        },
        images: {
          leakSourceImageCapture: 'Cattura Immagine della Fonte',
          add: 'Aggiungi',
        },
        index: {
          title: 'Crea record',
        },
      },
      leakRecordsList: {
        filters: {
          from: 'Da',
          to: 'A',
          qualifier: 'Qualificatore',
          savedFilters: 'Filtri salvati',
          filter: 'Filtro',
          selectFilter: 'Seleziona un filtro...',
          filterName: 'Nome del filtro',
          filterNameRequired: 'Il nome del filtro è obbligatorio',
          filtersNotAvailable: 'Filtri non disponibili',
          saveFilterTitle: 'Salva filtro',
          deleteSavedFilterTitle: "Si prega di confermare l'eliminazione del filtro",
          deleteSavedFilterMessage: 'Sei sicuro di voler eliminare il filtro "{{savedFilterName}}"?',
          createFilterSuccess: "Il filtro '{{filter}}' è stato creato con successo. Puoi accedervi in Filtri record → Filtri salvati",
          createFilterError: 'Errore durante la creazione del filtro. Per favore riprova più tardi.',
          deleteFilterSuccess: 'Filtro eliminato con successo',
          deleteFilterError: "Errore durante l'eliminazione del filtro. Per favore riprova più tardi.",
          emptyFilter: 'È vuoto',
        },
        modalAssignUsers: {
          assignLeakRecord: 'Assegna registrazione',
          selectAUserToAssign: 'Seleziona un utente da assegnare ai record selezionati',
          filterByName: 'Filtra per nome',
          filterByEmployeeName: 'Filtra per nome dei dipendenti',
          unexpectedError: 'Si è verificato un errore imprevisto',
          noUserFound: 'Nessun utente trovato',
          assigningActionForSelectedRecords: 'Assegnazione di azioni per i record selezionati...',
        },
        modalTransferRecords: {
          transferRecords: 'Trasferisci record',
          selectCompany: 'Seleziona azienda',
          selectCompanyPlaceholder: "Seleziona un'azienda",
          selectUser: 'Seleziona utente',
          selectUserPlaceholder: 'Seleziona un utente',
          noUserFound: 'Nessun utente trovato',
          unexpectedError: 'Errore imprevisto',
        },
        modalBulkEdit: {
          titleSingleRecord: 'Modifica in blocco di {{selectedRecordsCount}} record',
          title: 'Modifica in blocco di {{selectedRecordsCount}} record',
          selectAField: 'Seleziona un campo',
          verifyAction:
            'Stai per aggiornare record appartenenti ad altri utenti. Conferma inserendo il numero di record selezionati qui sotto.',
          matchCountError: 'Deve corrispondere al numero di record selezionati ({{selectedRecordsCount}})',
          moreThanOneType:
            'I record selezionati hanno più di un tipo. Alcuni campi potrebbero non essere disponibili per la modifica collettiva.',
          companyFilterRequired:
            'Per modificare i campi del percorso, applicare prima un filtro Azienda. I percorsi sono specifici per azienda/struttura.',
          selectCompanyForRoute:
            "I percorsi sono specifici per azienda/struttura. La selezione di un'azienda applicherà un filtro e chiuderà questa finestra. Sarà necessario riselezionare i record e riaprire la modifica collettiva.",
        },
        tableHead: {
          youAreSelecting: 'Stai selezionando:',
          visibleRecords: 'record visibili',
          andAllUnloadedRecords: 'e tutti i record non caricati.',
          allRecordsWillBeLoaded: 'Tutti i record saranno caricati e selezionati.',
          thisCanTakeAWhile: 'Questo potrebbe richiedere del tempo se hai molti record.',
          allRecords: 'Tutti i record, compresi quelli invisibili',
          selectAllRecords: 'Seleziona tutti i record.',
        },
        tableBody: {
          noRecordsToDisplay: 'Non ci sono record da visualizzare.',
        },
        toolBar: {
          assign: 'Assegna',
          assignToSelf: 'Assegna a me stesso',
          assignToSelfDialogTitle: 'Conferma assegnazione dei record',
          assignToSelfDialogMessage: 'Sei sicuro di voler assegnare {{len}} record a te stesso?',
          onEssentialPlan: 'Sei su un piano essenziale. Si prega di contattare support@prosaris.ca',
          bulkEdit: 'Modifica in blocco',
          transfer: 'Trasferisci',
          bulkEditSuccess: '{{len}} record aggiornato con successo',
          bulkEditSuccessPlural: '{{len}} record aggiornati con successo',
          bulkEditError: "Errore durante l'aggiornamento dei record. Si prega di riprovare più tardi",
          export: 'Esporta',
          exportPDF: 'Esporta in PDF',
          needAdminLicense:
            'Hai bisogno di una licenza amministrativa per accedere a questa funzionalità. Si prega di contattare support@prosaris.ca',
          create: 'Crea',
          deleteRecordMessage: 'Sei sicuro di voler eliminare il record selezionato?',
          deleteRecordMessagePlural: 'Sei sicuro di voler eliminare i record selezionati?',
          permissionDenied: 'Permesso negato!',
          notAllowedToDelete: 'Hai selezionato un record di qualcun altro che non ti è permesso eliminare. Rimuovilo dalla selezione.',
          generatingPDF: 'Generazione del PDF in corso...',
          csvExportProcessing: 'Il tuo file è in fase di elaborazione. Verrà scaricato automaticamente.',
          cannotGeneratePDF:
            'Purtroppo, non possiamo esportare {{numberSelected}} record in un documento PDF in questo momento. Seleziona fino a {{limitRecords}} record.',
          cannotExportMessage: 'Impossibile esportare {{numberSelected}} record',
          bulkEditLimitExceeded: 'Impossibile modificare più di {{maxAllowed}} record. Si prega di contattare support@prosaris.ca',
          selectAtLeastOneRecord: 'Si prega di selezionare almeno un record',
        },
        index: {
          cannotLoadLeakRecord: 'Ci dispiace, non possiamo caricare il record di perdita in questo momento',
          successfullyAssignedAllRecords: 'Tutti i record assegnati con successo',
          actionRecordAssigned: 'Record di azione assegnato!',
          actionRecordAssignedPlural: 'Record di azione assegnati!',
          errorWhileAssigningLeak: "Errore durante l'assegnazione della perdita. Per favore riprova più tardi.",
          successfullyDeletedAllRecords: 'Tutti i record eliminati con successo',
          successfullyDeletedRecord: '{{length}} record di perdita eliminato con successo',
          successfullyDeletedRecordPlural: '{{length}} record di perdita eliminati con successo',
          errorOnRecordsDelete: "Errore durante l'eliminazione dei record. Per favore riprova più tardi",
          leakPreview: 'Anteprima',
          leakRecord: 'Registrazione: ',
          failedAssignments: 'Assegnazioni non riuscite ({{failed}})',
          failedAssignmentCodes: {
            'B04:012': 'Il record è chiuso',
          },
          displayedRows: '{{from}}-{{to}} di {{count}}',
          rowsPerPage: 'Record per pagina:',
          previousPage: 'Pagina precedente',
          nextPage: 'Pagina successiva',
          csvExportSuccess: 'Esportazione completata con successo',
          csvExportError: "Errore durante l'esportazione. Per favore riprova più tardi.",
        },
      },
      tagList: {
        resetTag: 'Reimposta etichetta',
        dataExport: {
          smartLeakTagsFormat: 'Formato Smart Tags',
          smartLeakTagsDescription: 'Contiene i campi predefiniti presenti sulla pagina Smart Tags',
          standardLeakRecordFormat: 'Formato di registrazione standard',
          standardLeakRecordDescription: 'Contiene tutti i campi relativi ai registri di perdite',
        },
        filters: { smartLeakTagFilters: 'Filtri Smart Tag' },
        index: {
          cannotLoadTags: 'Spiacenti, al momento non possiamo caricare Smart Tag',
          updateLeakSuccess: 'Ripristino di Smart Tag riuscito.',
          updateLeakError: 'Errore durante il ripristino di Smart Tag. Si prega di riprovare più tardi.',
          bulkEditSuccess: 'Ripristinato con successo {{len}} Smart Tag',
          bulkEditSuccessPlural: 'Ripristinato con successo {{len}} Smart Tags',
          bulkEditError: 'Errore durante il ripristino di Smart Tags. Si prega di riprovare più tardi.',
          tagsFileName: 'Smart Tags',
          leakFileName: 'Record',
        },
        tableBody: {
          title: "Si prega di confermare la reimpostazione dell'etichetta",
          alertDialog: {
            dialogOne: 'Stai cercando di',
            dialogTwo: "reimpostare l'etichetta",
            dialogThree: 'da un registro di perdita con',
            dialogFour: "Stato dell'azione: APERTO",
            dialogFive: 'Vuoi procedere?',
          },
        },
        toolBar: {
          resetTags: 'Reimposta etichette',
          title: 'Si prega di confermare la reimpostazione in blocco delle etichette',
          alertDialog: {
            dialogOne: 'La tua selezione contiene',
            dialogTwo: 'record con',
            dialogTwoPlural: 'record con',
            dialogThree: "Stato dell'azione: APERTO",
            dialogFour: 'Vuoi procedere?',
          },
          exportFormatCSV: 'Seleziona un formato di esportazione per CSV',
          exportFormatPDF: 'Seleziona un formato di esportazione per PDF',
        },
      },
      myDashboard: {
        assignedActions: {
          index: {
            errorMessage: 'Errore durante il caricamento delle azioni assegnate. Per favore riprova.',
          },
        },
        kpi: {
          title: 'Indicatori chiave di prestazione',
          filters: 'Filtri',
          myData: 'I miei dati',
          companyData: 'Dati aziendali',
          financialTitle: 'Risparmio sui costi',
          leaksTitle: 'Statistiche degli eventi',
          energyTitle: 'Risparmio energetico',
          totalIdentified: 'Totale Identificato',
          repaired: 'Riparato',
          unrepaired: 'Non Riparato',
          ofTotal: 'del totale',
          myStanding: 'La Mia Posizione',
          gaugeTooltipLeaks:
            'Confronta il tuo conteggio di perdite con altri utenti che hanno registrato perdite nel periodo selezionato. La barra va dal numero più basso al più alto.',
          gaugeTooltipEnergy:
            'Confronta il tuo risparmio energetico con altri utenti che hanno registrato perdite nel periodo selezionato. La barra va dal valore kWh più basso al più alto.',
          gaugeTooltipCost:
            'Confronta il tuo costo con altri utenti che hanno registrato perdite nel periodo selezionato. I risultati sono raggruppati per valuta.',
          tooltipCostTotal:
            'Il valore totale della potenziale riduzione dei costi che hai identificato. Le classifiche includono tutti gli utenti della tua azienda che hanno identificato una riduzione dei costi.',
          tooltipCostRepaired: 'La porzione della riduzione dei costi identificata che è stata risolta.',
          tooltipCostUnrepaired: 'La porzione della riduzione dei costi identificata che rimane irrisolta.',
          tooltipLeaksTotal:
            'Il numero totale di registrazioni di perdite che hai creato e caricato sulla piattaforma. Le classifiche includono tutti gli utenti della tua azienda che hanno caricato almeno una registrazione.',
          tooltipLeaksRepaired: 'La porzione delle tue registrazioni che sono state risolte.',
          tooltipLeaksUnrepaired: 'La porzione delle tue registrazioni che rimangono irrisolte.',
          tooltipEnergyTotal:
            'Il valore totale del potenziale risparmio energetico che hai identificato. Le classifiche includono tutti gli utenti della tua azienda che hanno identificato un risparmio energetico.',
          tooltipEnergyRepaired: 'La porzione del tuo risparmio energetico identificato che è stata risolta.',
          tooltipEnergyUnrepaired: 'La porzione del tuo risparmio energetico identificato che rimane irrisolta.',
          gaugeLowest: 'Più basso',
          gaugeHighest: 'Più alto',
          noData: 'Nessun dato disponibile per i filtri selezionati.',
          apply: 'Applica',
          cancel: 'Annulla',
          changeDates: 'Cambia date',
          loading: 'Caricamento...',
          selectDateRange: 'Seleziona un intervallo di date',
          startDate: 'Data di inizio',
          endDate: 'Data di fine',
          selectDateRangeDescription: 'Scegli un intervallo di date e fai clic su Applica per visualizzare i tuoi KPI.',
          datePresets: {
            label: 'Preimpostazioni data',
            today: 'Oggi',
            yesterday: 'Ieri',
            last7Days: 'Ultimi 7 giorni',
            last30Days: 'Ultimi 30 giorni',
            thisWeek: 'Questa settimana',
            lastWeek: 'Settimana scorsa',
            thisMonth: 'Questo mese',
            lastMonth: 'Mese scorso',
            thisYear: "Quest'anno",
            lastYear: 'Anno scorso',
            allTime: 'Tutto il tempo',
          },
          calendar: {
            weekDays: {
              mon: 'Lu',
              tue: 'Ma',
              wed: 'Me',
              thu: 'Gi',
              fri: 'Ve',
              sat: 'Sa',
              sun: 'Do',
            },
            months: {
              january: 'Gennaio',
              february: 'Febbraio',
              march: 'Marzo',
              april: 'Aprile',
              may: 'Maggio',
              june: 'Giugno',
              july: 'Luglio',
              august: 'Agosto',
              september: 'Settembre',
              october: 'Ottobre',
              november: 'Novembre',
              december: 'Dicembre',
            },
          },
        },
        charts: {
          charts: {
            errorMessages: {
              errorMessageOne: 'Errore durante il caricamento dei record di perdita. Per favore riprova.',
            },
          },
        },
        index: {
          assignedActions: 'Azioni assegnate a te',
        },
      },
      export: {
        imageUrl: 'URL immagine record {{number}}',
        additionalImageUrl: 'URL immagine aggiuntiva perdita {{number}}',
        audioFileUrlOne: 'URL file audio',
        smartTag: 'Etichetta intelligente',
        workRef: 'Riferimento di lavoro',
        per: 'per ',
      },
      downloadApk: {
        pageTitle: 'PROSARIS - Scarica l’app',
        title: 'Scarica l’app PROSARIS',
        mobileInstructions:
          'Se stai visualizzando questa pagina su un tablet o dispositivo mobile, tocca il pulsante "Scarica" qui sotto per scaricare l’app PROSARIS sul tuo dispositivo.',
        desktopInstructions:
          'Se stai visualizzando questa pagina su un computer, scansiona il codice QR con il tuo tablet o dispositivo mobile e scarica l’app da lì.',
        downloadButton: 'Scarica',
        qrCodeLabel: 'Scarica l’app PROSARIS',
        additionalInstructions: {
          title: 'Istruzioni aggiuntive per il download',
          description:
            'Stai scaricando un APK (Android Package Kit) da un sito web e potresti incontrare misure di sicurezza aggiuntive rispetto al download da Google Play.',
          step1: 'Potrebbe comparire un avviso che dice "Il file potrebbe essere dannoso". Tocca "Scarica comunque".',
          step2:
            'Potresti ricevere una notifica che indica che il dispositivo "non può installare app sconosciute da questa fonte". Ti verrà chiesto di aprire le impostazioni del dispositivo.',
          step3: 'Nella pagina delle impostazioni, attiva l’interruttore per consentire il download di app sconosciute.',
          step4:
            'Potresti essere invitato a "Scansionare l’app" come misura di sicurezza finale. Dopo la scansione, ti verrà chiesto di scaricare l’app.',
        },
      },
    },
    languages: {
      English: 'Inglese',
      Chinese: 'Cinese',
      Spanish: 'Spagnolo',
      French: 'Francese',
      German: 'Tedesco',
      Norwegian: 'Norvegese',
      Italian: 'Italiano',
      Turkish: 'Turco',
      Japanese: 'Giapponese',
      Portuguese: 'Portoghese',
      Korean: 'Coreano',
    },
  },
};
